<template>
    <div>
        <div class="right_section">
            <div class="alignment_section d-flex" v-if="editable">
                <div
                    class="right_items w-100"
                    :class="{ checkbox_checked: implicitylocation.is_selected }"
                    v-for="(
                        implicitylocation, l_inx
                    ) in getGenderImprintLocations()"
                    :key="l_inx"
                >
                    <div
                        class="images_right"
                        @click="selectImprintLocations(l_inx)"
                    >
                        <img
                            class="direct"
                            :src="implicitylocation.image_path"
                            alt=""
                        />
                        <input
                            type="checkbox"
                            :name="'is_selected_location' + l_inx"
                            :class="{ checked: implicitylocation.is_selected }"
                            :id="'same-address' + l_inx"
                            :checked="implicitylocation.is_selected"
                        />
                    </div>
                    <p>{{ implicitylocation.location }}</p>
                </div>
            </div>
            <div class="tab-content mt_12" id="myTabContent" v-if="editable">
                <div
                    class="tab-pane fade show active"
                    role="tabpanel"
                    :aria-labelledb="active_gender_index + '-tab'"
                >
                    <div class="tab_pro_panel">
                        <div class="tabs_table d-md-flex size_color_table">
                            <div class="available_color_columns">
                                <div
                                    class="color d-flex align-items-center color_column"
                                >
                                    <img
                                        v-if="picked_color.swatches"
                                        class="color_box mr_10"
                                        :src="picked_color.swatches"
                                    />
                                    <div
                                        v-else
                                        class="color_box mr_10"
                                        :style="
                                            'background: ' + picked_color.hash
                                        "
                                    ></div>
                                    <h5 class="color-name">
                                        {{
                                            converToCamel(
                                                picked_color.color_name
                                            )
                                        }}
                                        - Sizes
                                    </h5>
                                </div>
                            </div>
                            <div class="sizez_columns">
                                <div class="d-flex flex-wrap inner_size_table">
                                    <div
                                        class="product_count"
                                        v-for="(
                                            gendersizes, indx
                                        ) in picked_color['unique_sizes']"
                                        :key="indx"
                                    >
                                        <div class="count_item_heading">
                                            <h6 class="m-0">
                                                {{ gendersizes.Size.size }}
                                            </h6>
                                            <span>
                                                {{
                                                    icPriceFormat(
                                                        gendersizes.cost || 0
                                                    )
                                                }}
                                            </span>
                                        </div>
                                        <div class="count_item_price">
                                            <input
                                                type="text"
                                                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                                v-model="gendersizes.quantity"
                                                @change="
                                                    calculatePricing(
                                                        active_gender_index,
                                                        gendersizes,
                                                        $event
                                                    )
                                                "
                                                class="form-control"
                                                placeholder="0"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="product_count total_count d-none"
                                    >
                                        <div class="count_item_heading">
                                            <h6 class="m-0">Total</h6>
                                        </div>
                                        <div class="count_item_price total_box">
                                            <b>{{
                                                icPriceFormat(
                                                    picked_color.total_cost_gender_wise
                                                )
                                            }}</b>
                                            <div
                                                class="dropdown"
                                                v-if="
                                                    picked_color.total_qty_gender_wise >
                                                    0
                                                "
                                            >
                                                <a
                                                    href="javascript:void(0);"
                                                    class="dropdown-toggle d-flex align-items-center"
                                                    :id="
                                                        'dropdownMenuButton' +
                                                        picked_color.id
                                                    "
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    <img
                                                        src="/maincss/images/path.png"
                                                        class="ml_6 path"
                                                    />
                                                </a>

                                                <div
                                                    class="dropdown-menu drop_product total_count_drop"
                                                    aria-labelledby="dropdownMenuButton"
                                                >
                                                    <h4
                                                        class="font_size_16 text_primary_blue py_2 px_20"
                                                    >
                                                        {{
                                                            converToCamel(
                                                                picked_color.color_name
                                                            )
                                                        }}
                                                        <span class="cross_ic">
                                                            <img
                                                                src="/maincss/images/cross.svg"
                                                            />
                                                        </span>
                                                    </h4>
                                                    <div class="scroll">
                                                        <div>
                                                            <div
                                                                class="col-md-12"
                                                            >
                                                                <div
                                                                    class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                >
                                                                    <div
                                                                        class="table-responsive"
                                                                    >
                                                                        <table
                                                                            width="100%"
                                                                            class="table-bordered comma-decimal-place table-data table-hover space_b"
                                                                        >
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>
                                                                                        Size
                                                                                    </th>
                                                                                    <th>
                                                                                        Quantity
                                                                                    </th>
                                                                                    <th>
                                                                                        Total
                                                                                    </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr
                                                                                    v-for="(
                                                                                        size,
                                                                                        ind
                                                                                    ) in picked_color[
                                                                                        'unique_sizes'
                                                                                    ]"
                                                                                    :key="
                                                                                        ind
                                                                                    "
                                                                                    v-show="
                                                                                        size.quantity >
                                                                                        0
                                                                                    "
                                                                                >
                                                                                    <td
                                                                                        class="size"
                                                                                    >
                                                                                        {{
                                                                                            size
                                                                                                .Size
                                                                                                .size
                                                                                        }}
                                                                                    </td>
                                                                                    <td>
                                                                                        {{
                                                                                            size.quantity
                                                                                        }}
                                                                                        *
                                                                                        {{
                                                                                            icPriceFormat(
                                                                                                size.cost
                                                                                            )
                                                                                        }}
                                                                                    </td>
                                                                                    <td>
                                                                                        {{
                                                                                            icPriceFormat(
                                                                                                size.total_cost
                                                                                            )
                                                                                        }}
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="col-md-12"
                                                            >
                                                                <div
                                                                    class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                    v-if="
                                                                        parseFloat(
                                                                            picked_color.total_design_fee
                                                                        ) > 0
                                                                    "
                                                                >
                                                                    <p
                                                                        class="font-weight-bold w-90 m-0"
                                                                    >
                                                                        Design
                                                                        Fee:
                                                                    </p>
                                                                    <p
                                                                        class="ml-auto mb-0"
                                                                    >
                                                                        {{
                                                                            picked_color.total_design_fee >=
                                                                            0
                                                                                ? icPriceFormat(
                                                                                      picked_color.total_design_fee
                                                                                  )
                                                                                : 0.0
                                                                        }}
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                    v-if="
                                                                        parseFloat(
                                                                            picked_color.front_number_fees
                                                                        ) > 0
                                                                    "
                                                                >
                                                                    <p
                                                                        class="font-weight-bold w-90 m-0"
                                                                    >
                                                                        Front
                                                                        Number
                                                                        Fee:
                                                                    </p>
                                                                    <p
                                                                        class="ml-auto mb-0"
                                                                    >
                                                                        {{
                                                                            picked_color.front_number_fees >=
                                                                            0
                                                                                ? icPriceFormat(
                                                                                      picked_color.front_number_fees
                                                                                  )
                                                                                : 0.0
                                                                        }}
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                    v-if="
                                                                        parseFloat(
                                                                            picked_color.back_name_fees
                                                                        ) > 0
                                                                    "
                                                                >
                                                                    <p
                                                                        class="font-weight-bold w-90 m-0"
                                                                    >
                                                                        Back
                                                                        Name
                                                                        Fee:
                                                                    </p>
                                                                    <p
                                                                        class="ml-auto mb-0"
                                                                    >
                                                                        {{
                                                                            picked_color.back_name_fees >=
                                                                            0
                                                                                ? icPriceFormat(
                                                                                      picked_color.back_name_fees
                                                                                  )
                                                                                : 0.0
                                                                        }}
                                                                    </p>
                                                                </div>

                                                                <div
                                                                    class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                    v-if="
                                                                        parseFloat(
                                                                            picked_color.back_number_fees
                                                                        ) > 0
                                                                    "
                                                                >
                                                                    <p
                                                                        class="font-weight-bold w-90 m-0"
                                                                    >
                                                                        Back
                                                                        Number
                                                                        Fee:
                                                                    </p>
                                                                    <p
                                                                        class="ml-auto mb-0"
                                                                    >
                                                                        {{
                                                                            picked_color.back_number_fees >=
                                                                            0
                                                                                ? icPriceFormat(
                                                                                      picked_color.back_number_fees
                                                                                  )
                                                                                : 0.0
                                                                        }}
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                    v-if="
                                                                        parseFloat(
                                                                            picked_color.front_number_decor_up_fees
                                                                        ) > 0
                                                                    "
                                                                >
                                                                    <p
                                                                        class="font-weight-bold w-90 m-0"
                                                                    >
                                                                        Front
                                                                        Number
                                                                        Decor Up
                                                                        Fee:
                                                                    </p>
                                                                    <p
                                                                        class="ml-auto mb-0"
                                                                    >
                                                                        {{
                                                                            picked_color.front_number_decor_up_fees >=
                                                                            0
                                                                                ? icPriceFormat(
                                                                                      picked_color.front_number_decor_up_fees
                                                                                  )
                                                                                : 0.0
                                                                        }}
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                    v-if="
                                                                        parseFloat(
                                                                            picked_color.back_name_decor_up_fees
                                                                        ) > 0
                                                                    "
                                                                >
                                                                    <p
                                                                        class="font-weight-bold w-90 m-0"
                                                                    >
                                                                        Back
                                                                        Name
                                                                        Decor Up
                                                                        Fee:
                                                                    </p>
                                                                    <p
                                                                        class="ml-auto mb-0"
                                                                    >
                                                                        {{
                                                                            picked_color.back_name_decor_up_fees >=
                                                                            0
                                                                                ? icPriceFormat(
                                                                                      picked_color.back_name_decor_up_fees
                                                                                  )
                                                                                : 0.0
                                                                        }}
                                                                    </p>
                                                                </div>

                                                                <div
                                                                    class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                    v-if="
                                                                        parseFloat(
                                                                            picked_color.back_number_decor_up_fees
                                                                        ) > 0
                                                                    "
                                                                >
                                                                    <p
                                                                        class="font-weight-bold w-90 m-0"
                                                                    >
                                                                        Back
                                                                        Number
                                                                        Decor Up
                                                                        Fee:
                                                                    </p>
                                                                    <p
                                                                        class="ml-auto mb-0"
                                                                    >
                                                                        {{
                                                                            picked_color.back_number_decor_up_fees >=
                                                                            0
                                                                                ? icPriceFormat(
                                                                                      picked_color.back_number_decor_up_fees
                                                                                  )
                                                                                : 0.0
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="select-imprint-area mt_24 popup_right_section">
                <div
                    class="row left_botom_0 validation-error-text"
                    v-if="colorsValidation != ''"
                >
                    {{ colorsValidation }}
                </div>
                <div
                    class="imprint-area-box imprint-product_area_box mb_40 popup_dropdown"
                >
                    <div id="accordion">
                        <div class="">
                            <div class="" id="select-one">
                                <h5
                                    class="mb-0"
                                    v-for="(
                                        implicitylocation, l_inx
                                    ) in getGenderImprintLocations()"
                                    :key="l_inx"
                                >
                                    <div
                                        class="left-chest-"
                                        v-if="implicitylocation.is_selected"
                                    >
                                        <div class="row left_botom_0">
                                            <div
                                                class="col-md-6 align-self-end drop-sec"
                                            >
                                                <label
                                                    class="label-head label-pointer"
                                                    for="left-chest"
                                                >
                                                    <img
                                                        v-if="
                                                            implicitylocation.collapse &&
                                                            l_inx == 0
                                                        "
                                                        :id="`collapseid${l_inx}`"
                                                        @click="
                                                            onCollapaseLocationColors(
                                                                implicitylocation
                                                            )
                                                        "
                                                        data-toggle="collapse"
                                                        :data-target="`#collapseColors${l_inx}`"
                                                        aria-expanded="true"
                                                        aria-controls="collapseOne"
                                                        src="/maincss/images/minus1.svg"
                                                    />
                                                    <img
                                                        v-else-if="
                                                            !implicitylocation.collapse &&
                                                            l_inx == 0
                                                        "
                                                        :id="`collapseid${l_inx}`"
                                                        @click="
                                                            onCollapaseLocationColors(
                                                                implicitylocation
                                                            )
                                                        "
                                                        data-toggle="collapse"
                                                        :data-target="`#collapseColors${l_inx}`"
                                                        aria-expanded="true"
                                                        aria-controls="collapseOne"
                                                        src="/maincss/images/plus-2.png"
                                                    />
                                                    <img
                                                        v-else-if="
                                                            implicitylocation.collapse &&
                                                            l_inx != 0
                                                        "
                                                        :id="`collapseid${l_inx}`"
                                                        @click="
                                                            onCollapaseLocationColors(
                                                                implicitylocation
                                                            )
                                                        "
                                                        data-toggle="collapse"
                                                        :data-target="`#collapseColors${l_inx}`"
                                                        aria-expanded="true"
                                                        aria-controls="collapseOne"
                                                        src="/maincss/images/minus1.svg"
                                                    />
                                                    <img
                                                        v-else-if="
                                                            !implicitylocation.collapse &&
                                                            l_inx != 0
                                                        "
                                                        :id="`collapseid${l_inx}`"
                                                        @click="
                                                            onCollapaseLocationColors(
                                                                implicitylocation
                                                            )
                                                        "
                                                        data-toggle="collapse"
                                                        :data-target="`#collapseColors${l_inx}`"
                                                        aria-expanded="true"
                                                        aria-controls="collapseOne"
                                                        src="/maincss/images/plus-2.png"
                                                    />
                                                    {{
                                                        implicitylocation.location
                                                    }}
                                                    <p
                                                        v-if="
                                                            genderGroups[
                                                                active_gender_index
                                                            ]['item']
                                                                .decoration_type ==
                                                            1
                                                        "
                                                    >
                                                        (choose ink colors)
                                                    </p>
                                                    <p
                                                        v-if="
                                                            genderGroups[
                                                                active_gender_index
                                                            ]['item']
                                                                .decoration_type ==
                                                            2
                                                        "
                                                    >
                                                        (choose thread colors)
                                                    </p>
                                                    <p
                                                        v-if="
                                                            genderGroups[
                                                                active_gender_index
                                                            ]['item']
                                                                .decoration_type ==
                                                            3
                                                        "
                                                    >
                                                        (choose vinyl colors)
                                                    </p>
                                                </label>
                                            </div>

                                            <div class="col-md-3">
                                                <div class="form-group mt-0">
                                                    <v-select
                                                        width="100%"
                                                        placeholder="Select-colors"
                                                        label="value"
                                                        :reduce="
                                                            (color) => color.id
                                                        "
                                                        :options="
                                                            imprintcityColors
                                                        "
                                                        v-model="
                                                            implicitylocation.no_of_color
                                                        "
                                                        @input="
                                                            selectNumberOfColors(
                                                                implicitylocation,
                                                                $event
                                                            )
                                                        "
                                                        :style="
                                                            disable_imprint_locations
                                                                ? disabled_styles
                                                                : ''
                                                        "
                                                    >
                                                    </v-select>
                                                </div>
                                            </div>
                                            <div
                                                class="col-md-2"
                                                v-if="
                                                    implicitylocation.no_of_color ===
                                                        'full_color' ||
                                                    implicitylocation.is_full_color ===
                                                        true
                                                "
                                            >
                                                <div class="">
                                                    <input
                                                        type="number"
                                                        class="form-control number-input"
                                                        :value="
                                                            implicitylocation.full_color_count ||
                                                            1
                                                        "
                                                        @input="
                                                            updateFullColorCount(
                                                                implicitylocation,
                                                                $event.target
                                                                    .value
                                                            )
                                                        "
                                                        min="1"
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                class="col-md-3 cost_right d-none"
                                            >
                                                <span
                                                    class="mt-1"
                                                    v-if="
                                                        implicitylocation.decoration_fee
                                                    "
                                                    >+
                                                    {{
                                                        icPriceFormat(
                                                            implicitylocation.decoration_fee ||
                                                                0
                                                        )
                                                    }}</span
                                                >
                                            </div>
                                        </div>

                                        <div
                                            :id="`collapseColors${l_inx}`"
                                            :class="
                                                l_inx == 0
                                                    ? 'accordion-collapse collapse show'
                                                    : 'accordion-collapse collapse'
                                            "
                                            aria-labelledby="select-one"
                                            data-parent="#accordion"
                                        >
                                            <div class="card-body">
                                                <!-- Full Color Input and Color Selection -->

                                                <div
                                                    class="row select_color"
                                                    v-show="
                                                        (implicitylocation.no_of_color >
                                                            0 &&
                                                            implicitylocation.no_of_color !==
                                                                'full_color' &&
                                                            !implicitylocation.is_full_color) ||
                                                        implicitylocation.no_of_color ===
                                                            'full_color' ||
                                                        implicitylocation.is_full_color ===
                                                            true
                                                    "
                                                    v-for="(
                                                        colors, c_inx
                                                    ) in implicitylocation.colors"
                                                    :key="c_inx"
                                                >
                                                    <div
                                                        class="col-md-2 align-self-end drop_menus"
                                                    >
                                                        <label>
                                                            <span
                                                                v-if="
                                                                    genderGroups[
                                                                        active_gender_index
                                                                    ]['item']
                                                                        .decoration_type ==
                                                                    1
                                                                "
                                                                >Ink -
                                                                {{
                                                                    c_inx + 1
                                                                }}</span
                                                            >
                                                            <span
                                                                v-else-if="
                                                                    genderGroups[
                                                                        active_gender_index
                                                                    ]['item']
                                                                        .decoration_type ==
                                                                    2
                                                                "
                                                                >Thread -
                                                                {{
                                                                    c_inx + 1
                                                                }}</span
                                                            >
                                                            <span
                                                                v-else-if="
                                                                    genderGroups[
                                                                        active_gender_index
                                                                    ]['item']
                                                                        .decoration_type ==
                                                                    3
                                                                "
                                                                >Vinyl -
                                                                {{
                                                                    c_inx + 1
                                                                }}</span
                                                            >
                                                            <span
                                                                v-else-if="
                                                                    genderGroups[
                                                                        active_gender_index
                                                                    ]['item']
                                                                        .decoration_type ==
                                                                    0
                                                                "
                                                            >
                                                                <template
                                                                    v-if="
                                                                        activeDecorationService &&
                                                                        activeDecorationService.name &&
                                                                        (activeDecorationService.name
                                                                            .toLowerCase()
                                                                            .includes(
                                                                                'embroidery'
                                                                            ) ||
                                                                            activeDecorationService.name
                                                                                .toLowerCase()
                                                                                .includes(
                                                                                    'emb'
                                                                                ))
                                                                    "
                                                                >
                                                                    Thread -
                                                                    {{
                                                                        c_inx +
                                                                        1
                                                                    }}
                                                                </template>
                                                                <template
                                                                    v-else-if="
                                                                        activeDecorationService &&
                                                                        activeDecorationService.name &&
                                                                        activeDecorationService.name
                                                                            .toLowerCase()
                                                                            .includes(
                                                                                'print'
                                                                            )
                                                                    "
                                                                >
                                                                    Ink -
                                                                    {{
                                                                        c_inx +
                                                                        1
                                                                    }}
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                    Color -
                                                                    {{
                                                                        c_inx +
                                                                        1
                                                                    }}
                                                                </template>
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div
                                                        class="col-md-9 d-flex flex-col"
                                                    >
                                                        <div
                                                            :class="
                                                                genderGroups[
                                                                    active_gender_index
                                                                ].colors
                                                                    .length > 3
                                                                    ? 'row owl-carousel ink-color-slider'
                                                                    : 'row ink-color-slider carousel_minimum'
                                                            "
                                                        >
                                                            <div
                                                                class="form-group mt_0"
                                                                v-for="(
                                                                    color,
                                                                    color_index
                                                                ) in genderGroups[
                                                                    active_gender_index
                                                                ].colors"
                                                                :key="
                                                                    color_index
                                                                "
                                                            >
                                                                <div
                                                                    class="color_top"
                                                                    v-if="
                                                                        c_inx ==
                                                                        0
                                                                    "
                                                                >
                                                                    <img
                                                                        v-if="
                                                                            color.swatches
                                                                        "
                                                                        :src="
                                                                            color.swatches
                                                                        "
                                                                        class="checkmark"
                                                                        :class="[
                                                                            color.hash ==
                                                                            '#FFFFFF'
                                                                                ? 'bg-white'
                                                                                : ''
                                                                        ]"
                                                                    />
                                                                    <span
                                                                        v-else
                                                                        v-bind:style="
                                                                            'background:' +
                                                                            color.hash
                                                                        "
                                                                    ></span>
                                                                    <h4>
                                                                        {{
                                                                            color.color_name
                                                                        }}
                                                                    </h4>
                                                                </div>
                                                                <v-select
                                                                    :filter="
                                                                        fuseSearch
                                                                    "
                                                                    :options="
                                                                        vendorColors
                                                                    "
                                                                    :get-option-label="
                                                                        (
                                                                            option
                                                                        ) =>
                                                                            option.color_name
                                                                    "
                                                                    :value="
                                                                        getLocationColor(
                                                                            l_inx,
                                                                            c_inx,
                                                                            color_index
                                                                        )
                                                                    "
                                                                    placeholder="Select"
                                                                    @input="
                                                                        selectVendorColors(
                                                                            $event,
                                                                            c_inx,
                                                                            l_inx,
                                                                            color_index
                                                                        )
                                                                    "
                                                                    :disabled="
                                                                        disable_imprint_locations
                                                                            ? true
                                                                            : false
                                                                    "
                                                                >
                                                                    <!-- eslint-disable -->
                                                                    <template
                                                                        #selected-option-container="{
                                                                            option,
                                                                            deselect,
                                                                            multiple,
                                                                            disabled
                                                                        }"
                                                                    >
                                                                        <span
                                                                            class="vs__selected"
                                                                        >
                                                                            <cite
                                                                                v-if="
                                                                                    option.color_value
                                                                                "
                                                                                class="imprint_color_box color-box-tooltip"
                                                                                v-bind:style="
                                                                                    'background:' +
                                                                                    option.color_value
                                                                                "
                                                                                :title="
                                                                                    option.color_value
                                                                                "
                                                                                :data-hex="
                                                                                    option.color_value
                                                                                "
                                                                            ></cite>
                                                                            <img
                                                                                v-else-if="
                                                                                    option.swatch_file
                                                                                "
                                                                                class="imprint_color_box"
                                                                                :src="
                                                                                    option.swatch_file
                                                                                "
                                                                                alt=""
                                                                            />
                                                                            <span
                                                                                v-if="
                                                                                    option.color_id ==
                                                                                        0 &&
                                                                                    (!activeDecorationService ||
                                                                                    !activeDecorationService.name ||
                                                                                    (!activeDecorationService.name.toLowerCase().includes('print') &&
                                                                                    !activeDecorationService.name.toLowerCase().includes('embroidery') &&
                                                                                    !activeDecorationService.name.toLowerCase().includes('emb')))
                                                                                "
                                                                            >
                                                                                {{
                                                                                    option.color_value || option.color_name
                                                                                }}
                                                                            </span>
                                                                            <span
                                                                                v-else
                                                                            >
                                                                                {{
                                                                                    option.color_name
                                                                                }}
                                                                            </span>
                                                                            <span
                                                                                v-if="
                                                                                    option.color_id ==
                                                                                        0 &&
                                                                                    option.non_standard_fee
                                                                                "
                                                                                style="
                                                                                    margin-top: 1.2px;
                                                                                    margin-left: 1px;
                                                                                "
                                                                                >{{
                                                                                    icPriceFormat(
                                                                                        option.non_standard_fee ||
                                                                                            0
                                                                                    )
                                                                                }}</span
                                                                            >
                                                                            <span
                                                                                v-else-if="
                                                                                    option.decor_upcharge
                                                                                "
                                                                                style="
                                                                                    margin-top: 1.2px;
                                                                                    margin-left: 1px;
                                                                                "
                                                                                >{{
                                                                                    icPriceFormat(
                                                                                        option.decor_upcharge ||
                                                                                            0
                                                                                    )
                                                                                }}</span
                                                                            >
                                                                        </span>
                                                                    </template>
                                                                    <!-- eslint-enable -->
                                                                    <template
                                                                        #option="option"
                                                                    >
                                                                        <span
                                                                            v-if="
                                                                                option.color_id ==
                                                                                0
                                                                            "
                                                                        >
                                                                            <cite
                                                                                class="imprint_color_box color-box-tooltip"
                                                                                v-bind:style="
                                                                                    'background:' +
                                                                                    option.color_value
                                                                                "
                                                                                :title="
                                                                                    option.color_value
                                                                                "
                                                                                :data-hex="
                                                                                    option.color_value
                                                                                "
                                                                            ></cite>
                                                                            <span
                                                                                v-if="
                                                                                    option.color_id ==
                                                                                        0 &&
                                                                                    (!activeDecorationService ||
                                                                                    !activeDecorationService.name ||
                                                                                    (!activeDecorationService.name.toLowerCase().includes('print') &&
                                                                                    !activeDecorationService.name.toLowerCase().includes('embroidery') &&
                                                                                    !activeDecorationService.name.toLowerCase().includes('emb')))
                                                                                "
                                                                            >
                                                                                {{
                                                                                    option.color_value || option.color_name
                                                                                }}
                                                                            </span>
                                                                            <span
                                                                                v-else
                                                                            >
                                                                                {{
                                                                                    option.color_name
                                                                                }}
                                                                            </span>
                                                                        </span>
                                                                        <span
                                                                            v-else
                                                                        >
                                                                            <cite
                                                                                v-if="
                                                                                    option.color_value
                                                                                "
                                                                                class="imprint_color_box color-box-tooltip"
                                                                                v-bind:style="
                                                                                    'background:' +
                                                                                    option.color_value
                                                                                "
                                                                                :title="
                                                                                    option.color_value
                                                                                "
                                                                                :data-hex="
                                                                                    option.color_value
                                                                                "
                                                                            ></cite>
                                                                            <img
                                                                                v-else-if="
                                                                                    option.swatch_file
                                                                                "
                                                                                class="imprint_color_box"
                                                                                :src="
                                                                                    option.swatch_file
                                                                                "
                                                                                alt=""
                                                                            />
                                                                            <span
                                                                                v-if="
                                                                                    option.color_id ==
                                                                                        0 &&
                                                                                    (!activeDecorationService ||
                                                                                    !activeDecorationService.name ||
                                                                                    (!activeDecorationService.name.toLowerCase().includes('print') &&
                                                                                    !activeDecorationService.name.toLowerCase().includes('embroidery') &&
                                                                                    !activeDecorationService.name.toLowerCase().includes('emb')))
                                                                                "
                                                                            >
                                                                                {{
                                                                                    option.color_value || option.color_name
                                                                                }}
                                                                            </span>
                                                                            <span
                                                                                v-else
                                                                            >
                                                                                {{
                                                                                    option.color_name
                                                                                }}
                                                                            </span>

                                                                            <span
                                                                                v-if="
                                                                                    option.color_id ==
                                                                                        0 &&
                                                                                    option.non_standard_fee
                                                                                "
                                                                                >{{
                                                                                    icPriceFormat(
                                                                                        option.decor_upcharge ||
                                                                                            0
                                                                                    )
                                                                                }}</span
                                                                            >
                                                                            <span
                                                                                v-else-if="
                                                                                    option.decor_upcharge
                                                                                "
                                                                                >{{
                                                                                    icPriceFormat(
                                                                                        option.decor_upcharge ||
                                                                                            0
                                                                                    )
                                                                                }}</span
                                                                            >
                                                                        </span>
                                                                    </template>
                                                                </v-select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="d-flex col-md-1 slide_buttons"
                                                        v-if="
                                                            c_inx == 0 &&
                                                            genderGroups[
                                                                active_gender_index
                                                            ].colors.length > 3
                                                        "
                                                    >
                                                        <img
                                                            src="/maincss/images/link_blue_arow.svg"
                                                            alt="icon"
                                                            class="customPrevBtn"
                                                        />
                                                        <img
                                                            src="/maincss/images/link_blue_arow.svg"
                                                            alt="icon"
                                                            class="customNextBtn"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="">
                <div
                    v-if="
                        activeDecorationService &&
                        genderGroups[active_gender_index].total_qty > 0
                    "
                >
                    <PCNAPriceBreakdown
                        v-if="activeDecorationService.decoration_type === 0"
                        :key="
                            'pcna_' +
                            activeDecorationService.id +
                            '_' +
                            genderGroups[active_gender_index].total_qty
                        "
                        :quantity="genderGroups[active_gender_index].total_qty"
                        :other-services="mergedOtherServices"
                        :base-cost="currentBreakdown.baseCost"
                        :run-charge="currentBreakdown.runCharge"
                        :run-charge-details="
                            currentBreakdown.runChargeDetails || []
                        "
                        :setup-fee="currentBreakdown.setupFee"
                        :subtotal="currentBreakdown.totalCost"
                        :total-discount="currentBreakdown.totalDiscount"
                        :discount-config="activeProductDiscount"
                        :imprint-locations="
                            getGenderImprintLocationsWithColors()
                        "
                        :service-master-data="
                            activeDecorationService.master_service || {}
                        "
                        :stitch-count="0"
                        :vendor-colors="vendorColors"
                        :color-size-combinations="
                            getColorSizeCombinations(
                                genderGroups[active_gender_index]
                            )
                        "
                    />

                    <ImprintCityPriceBreakdown
                        v-else
                        :key="
                            'imprint_' +
                            activeDecorationService.id +
                            '_' +
                            genderGroups[active_gender_index].total_qty
                        "
                        :quantity="genderGroups[active_gender_index].total_qty"
                        :design-fee="currentBreakdown.designFee"
                        :total-discount="currentBreakdown.totalDiscount"
                        :discount-config="activeProductDiscount"
                        :other-services="mergedOtherServices"
                        :base-cost="currentBreakdown.baseCost"
                        :run-charge="currentBreakdown.runCharge"
                        :setup-fee="currentBreakdown.setupFee"
                        :total-cost="currentBreakdown.totalCost"
                        :run-charge-details="currentBreakdown.runChargeDetails"
                        :imprint-locations="getGenderImprintLocations()"
                        :service-master-data="
                            activeDecorationService.master_service || {}
                        "
                        :active-decoration-service="
                            activeDecorationService || null
                        "
                        :decoration-pricing-data="
                            (activeDecorationService && 
                             activeDecorationService.price_decoration_bulk && 
                             typeof activeDecorationService.price_decoration_bulk === 'object' && 
                             !Array.isArray(activeDecorationService.price_decoration_bulk))
                                ? activeDecorationService.price_decoration_bulk
                                : null
                        "
                        :decoration-type="
                            activeDecorationService.decoration_type || 1
                        "
                        :total-quantity="
                            genderGroups[active_gender_index].total_qty
                        "
                        :vendor-colors="vendorColors"
                        :color-size-combinations="
                            getColorSizeCombinations(
                                genderGroups[active_gender_index]
                            )
                        "
                    />
                </div>
                <!-- <a
                        href="javascript:void(0);"
                        class="dropdown-toggle d-flex align-items-center"
                        data-toggle="modal"
                        data-target="#priceBreakupChargesModal"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <img src="/maincss/images/path.png" class="ml_6 path" />
                    </a> -->
            </div>
        </div>
        <!-- PRICE BREAKUP CHARGES MODAL -->
        <!-- <div
            id="priceBreakupChargesModal"
            class="modal login-form-popup like_design_popup fade h-auto price_backup_modal total-cost-popup"
            tabindex="-1"
            aria-labelledby="art-work"
            aria-hidden="true"
            data-keyboard="false"
            data-backdrop="static"
        >
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="header_items">
                            <div>
                                <h5 class="modal-title">Cost</h5>
                            </div>

                            <div class="close_modal">
                                <a
                                    href="#"
                                    class="popup-close art_poup_close"
                                    id="popup-close"
                                    data-dismiss="modal"
                                    ref="popupclose"
                                >
                                    <span aria-hidden="true" v-tooltip="'Close'"
                                        >&times;</span
                                    >
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div
                            class="d-flex align-items-center justify-content-between"
                        >
                            <p class="font-weight-bold">Sub Total:</p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .subtotal
                                    )
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index]
                                    .total_color_fee
                            "
                        >
                            <p class="font-weight-bold">
                                Decoration Colors Fee:
                            </p>
                            <p>
                                {{
                                    genderGroups[active_gender_index]
                                        .total_color_fee
                                        ? icPriceFormat(
                                              genderGroups[active_gender_index]
                                                  .total_color_fee
                                          )
                                        : icPriceFormat(0.0)
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                typeof genderGroups[active_gender_index]
                                    .total_setup_fee === 'number'
                            "
                        >
                            <p class="font-weight-bold">
                                <span
                                    v-if="
                                        genderGroups[active_gender_index].item
                                            .decoration_type == 1
                                    "
                                >
                                    Per Color Setup Fee ({{
                                        genderGroups[active_gender_index]
                                            .total_decoration_colors
                                    }}
                                    *
                                    {{
                                        icPriceFormat(
                                            genderGroups[active_gender_index]
                                                .per_color_setup_cost
                                        )
                                    }}):
                                </span>
                                <span
                                    v-else-if="
                                        genderGroups[active_gender_index].item
                                            .decoration_type == 2
                                    "
                                >
                                    Digitizing Fee:
                                </span>
                                <span
                                    v-else-if="
                                        genderGroups[active_gender_index].item
                                            .decoration_type == 0
                                    "
                                >
                                    Setup Fee:
                                </span>
                                <span v-else> Setup/Other Fee: </span>
                            </p>

                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_setup_fee || 0
                                    )
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index]
                                    .total_design_fee
                            "
                        >
                            <p class="font-weight-bold">Design Fee:</p>
                            <p>
                                {{
                                    genderGroups[active_gender_index]
                                        .total_design_fee
                                        ? icPriceFormat(
                                              genderGroups[active_gender_index]
                                                  .total_design_fee
                                          )
                                        : 0.0
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index]
                                    .total_discount_value
                            "
                        >
                            <p class="font-weight-bold">Discount:</p>
                            <p>
                                -
                                {{
                                    genderGroups[active_gender_index]
                                        .total_discount_value
                                        ? icPriceFormat(
                                              genderGroups[active_gender_index]
                                                  .total_discount_value
                                          )
                                        : icPriceFormat(0.0)
                                }}
                            </p>
                        </div>

                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="totalNonStandardFees || (genderGroups[active_gender_index] && genderGroups[active_gender_index].total_non_standard_fees > 0)"
                        >
                            <p
                                class="font-weight-bold"
                                v-if="
                                    genderGroups[active_gender_index]['item']
                                        .decoration_type == 1
                                "
                            >
                                Custom Color Ink Fee (
                                {{ totalNonStandardColors && totalNonStandardColors.length ? totalNonStandardColors.length : 0 }} *
                                {{ icPriceFormat(nonStandardFeePerColor || 0) }} ):
                            </p>
                            <p
                                class="font-weight-bold"
                                v-if="
                                    genderGroups[active_gender_index]['item']
                                        .decoration_type == 2
                                "
                            >
                                Custom Color Thread Fee (
                                {{ totalNonStandardColors && totalNonStandardColors.length ? totalNonStandardColors.length : 0 }} *
                                {{ icPriceFormat(nonStandardFeePerColor || 0) }} ):
                            </p>
                            <p
                                class="font-weight-bold"
                                v-if="
                                    genderGroups[active_gender_index]['item']
                                        .decoration_type == 0 &&
                                    getPCNAFeePerColor() > 0
                                "
                            >
                                <template v-if="activeDecorationService && activeDecorationService.name && (activeDecorationService.name.toLowerCase().includes('embroidery') || activeDecorationService.name.toLowerCase().includes('emb'))">
                                    Custom Color Thread Fee (
                                    {{ getPCNAMixColorCount() }} *
                                    {{ icPriceFormat(getPCNAFeePerColor()) }} ):
                                </template>
                                <template v-else-if="activeDecorationService && activeDecorationService.name && activeDecorationService.name.toLowerCase().includes('print')">
                                    Custom Color Ink Fee (
                                    {{ getPCNAMixColorCount() }} *
                                    {{ icPriceFormat(getPCNAFeePerColor()) }} ):
                                </template>
                            </p>
                            <p>{{ icPriceFormat(totalNonStandardFees || (genderGroups[active_gender_index] && genderGroups[active_gender_index].total_non_standard_fees) || 0) }}</p>
                        </div>

                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index] &&
                                genderGroups[active_gender_index].total_front_number_fees > 0
                            "
                        >
                            <p class="font-weight-bold">Front Number Fee:</p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_front_number_fees
                                    )
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index] &&
                                genderGroups[active_gender_index].total_back_name_fees > 0
                            "
                        >
                            <p class="font-weight-bold">Back Name Fee:</p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_back_name_fees
                                    )
                                }}
                            </p>
                        </div>

                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index] &&
                                genderGroups[active_gender_index].total_back_number_fees > 0
                            "
                        >
                            <p class="font-weight-bold">Back Number Fee:</p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_back_number_fees
                                    )
                                }}
                            </p>
                        </div>

                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index]
                                    .total_front_number_decor_up_fees
                            "
                        >
                            <p class="font-weight-bold">
                                Front Number Decor Up Fee:
                            </p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_front_number_decor_up_fees
                                    )
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index]
                                    .total_back_name_decor_up_fees
                            "
                        >
                            <p class="font-weight-bold">
                                Back Name Decor Up Fee:
                            </p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_back_name_decor_up_fees
                                    )
                                }}
                            </p>
                        </div>

                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index]
                                    .total_back_number_decor_up_fees
                            "
                        >
                            <p class="font-weight-bold w-25">
                                Back Number Decor Up Fee:
                            </p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_back_number_decor_up_fees
                                    )
                                }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import ApiService from "@/common/api.service";
import PCNAPriceBreakdown from "@/views/frontend/products/components/PCNAPriceBreakdown.vue";
import ImprintCityPriceBreakdown from "@/views/frontend/products/components/ImprintCityPriceBreakdown.vue";
export default {
    name: "ItemDetails",
    components: {
        PCNAPriceBreakdown,
        ImprintCityPriceBreakdown
    },
    props: {
        productId: {
            type: Number
        },
        product: {
            type: Object
        },
        genderGroups: {
            type: Array,
            default: () => []
        },
        decorationColors: {
            type: Array,
            default: () => []
        },
        allDecorationColors: {
            type: Object,
            default: () => {}
        },
        tshirtSides: {
            type: Array
        },
        vendorColors: {
            type: Array,
            default: () => []
        },
        fuseSearch: {
            required: false,
            type: Function
        },
        activeColorIndex: {
            required: true,
            default: () => 0
        },
        saveNewDesigns: {
            required: true,
            type: Function
        },
        addToCart: {
            required: true,
            type: Function
        },
        updatePrintAreas: {
            required: true,
            type: Function
        },
        totalNonStandardFees: {
            type: Number
        },
        nonStandardFeePerColor: {
            type: Number,
            defaullt: 0
        },
        totalNonStandardColors: {
            type: Array,
            default: () => {}
        },
        canvasDesignsStatus: {
            type: Boolean,
            default: false
        },
        colorsValidation: {
            type: String,
            default: ""
        },
        colorsCount: {
            type: Number,
            default: 0
        },
        buildItemId: {
            type: Number,
            default: null
        },
        editable: {
            type: Boolean,
            default: true
        },
        cartQuantity: {
            type: Number,
            default: 0
        },
        useImprintcityTemplate: {
            type: Number,
            required: false,
            default: null
        },
        activeDecorationService: {
            type: Object,
            default: () => null
        },
        otherServices: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        activeProductDiscount() {
            // Check if product and discount data exist
            const discount = this.product
                ? this.product.MainNewProductDiscount
                : null;

            // Return null if there's no discount or its status is inactive
            if (!discount || !discount.status) {
                return null;
            }

            const today = new Date();
            today.setHours(0, 0, 0, 0); // Compare date part only

            // Check start date
            if (discount.start_date) {
                const startDate = new Date(discount.start_date);
                if (today < startDate) {
                    return null; // Not started yet
                }
            }

            // Check end date
            if (discount.end_date) {
                const endDate = new Date(discount.end_date);
                if (today > endDate) {
                    return null; // Expired
                }
            }

            // If all checks pass, discount is active
            return discount;
        },
        // Merge VendorFees with otherServices for price breakdown components
        mergedOtherServices() {
            const vendorFees =
                this.product && this.product.VendorFees
                    ? this.product.VendorFees
                    : [];
            // Merge VendorFees with otherServices, prioritizing VendorFees
            return [...vendorFees, ...(this.otherServices || [])];
        }
    },
    data() {
        return {
            // Variables for imprint locations and colors by jinendra
            originalTotalCost: 0,
            originalImprintLocations: [],
            imprintcityColors: [],
            default_imprint_colors: [
                {
                    id: 1,
                    value: "1-colors"
                },
                {
                    id: 2,
                    value: "2-colors"
                },
                {
                    id: 3,
                    value: "3-colors"
                },
                {
                    id: 4,
                    value: "4-colors"
                },
                {
                    id: 5,
                    value: "5-colors"
                },
                {
                    id: 6,
                    value: "6-colors"
                }
            ],
            decoration_price_template_values: [],
            decoration_price_template_values_for_imprint: [],
            active_gender_index: 0,
            setup_fee_applied_gender_index: -1,
            setup_fee: 0,
            picked_color: null,
            current_cart_quantity: 0,
            index_prev: 0,
            disable_imprint_locations: false,
            disabled_styles: {
                "pointer-events": "none !important",
                color: "#bfcbd9 !important",
                cursor: "not-allowed !important",
                "background-image": "none !important",
                "background-color": "#eef1f6 !important",
                "border-color": "#d1dbe5 !important"
            },
            markup_tiers: [],
            currentBreakdown: {
                baseCost: 0,
                runCharge: 0,
                setupFee: 0,
                totalCost: 0,
                totalDiscount: 0,
                designFee: 0,
                runChargeDetails: []
            },
            page_status: 0 // 0 for beforeMount, 1 for mounted
        };
    },
    watch: {
        // Watch for changes in the active color index prop
        activeColorIndex: {
            handler(newIndex, oldIndex) {
                if (
                    newIndex >= 0 &&
                    this.genderGroups[this.active_gender_index] &&
                    newIndex <
                        this.genderGroups[this.active_gender_index].colors
                            .length
                ) {
                    this.picked_color =
                        this.genderGroups[this.active_gender_index].colors[
                            newIndex
                        ];
                    this.$nextTick(() => {
                        this.calculatePricing(this.active_gender_index);
                    });
                } else {
                    console.warn(
                        "Watcher: Invalid activeColorIndex or gender data:",
                        newIndex
                    );
                    this.picked_color = null; // Reset if index is invalid
                }
            },
            immediate: true
        },
        decorationColors() {
            /* eslint-disable */
            let element = document.getElementById(
                "collapseColors" + this.index_prev
            );
            if (
                this.decorationColors.length > 0 &&
                !element.classList.contains("show")
            ) {
                this.genderGroups[this.active_gender_index].imprint_locations[
                    this.index_prev
                ].collapse = false;
                //console.log("collapseid" + this.index_prev);
                $("#collapseid" + this.index_prev).click();
            }
            /* eslint-enable */
        },
        colorsCount: {
            handler(newCount) {
                let colors = [];

                // Check if activeDecorationService has is_full_color set to true
                if (
                    this.activeDecorationService &&
                    this.activeDecorationService.is_full_color === true
                ) {
                    // Show only "1-color" and "Full color" options
                    colors.push({
                        id: 1,
                        value: "1-color"
                    });
                    colors.push({
                        id: "full_color",
                        value: "Full color"
                    });
                } else if (newCount > 0) {
                    // Normal case: show all color options from 1 to newCount
                    for (let i = 1; i <= newCount; i++) {
                        colors.push({
                            id: i,
                            value: `${i}-color${i > 1 ? "s" : ""}`
                        });
                    }
                }

                this.imprintcityColors = colors;
            },
            immediate: true
        },
        activeDecorationService: {
            handler(newService, oldService) {
                // Update colors when service changes, especially if is_full_color changes
                if (newService !== oldService) {
                    // Trigger colorsCount watcher to update dropdown options
                    this.$nextTick(() => {
                        this.colorsCount = this.colorsCount; // Trigger watcher
                    });
                }
            },
            deep: true
        },
        genderGroups: {
            handler: function (val, oldVal) {
                /* eslint-disable */
                if (
                    this.genderGroups[this.active_gender_index].colors.length >
                    3
                ) {
                    let timer = 500;
                    setTimeout(() => {
                        let owl = $(".ink-color-slider").owlCarousel({
                            loop: false,
                            // stagePadding: 0,
                            autoWidth: false,
                            margin: 0,
                            items: 3,
                            autoplay: false,
                            autoplayTimeout: 4000,
                            autoplayHoverPause: false,
                            responsiveClass: true,
                            navigation: false,
                            dots: false
                            // responsive: {
                            // 	0: {
                            // 		items: 6,
                            // 		nav: true
                            // 	},
                            // 	360: {
                            // 		items: 6,
                            // 		nav: true
                            // 	},
                            // 	600: {
                            // 		items: 5,
                            // 		nav: true
                            // 	},
                            // 	767: {
                            // 		items: 6,
                            // 		nav: true
                            // 		// loop: true,
                            // 	},
                            // 	1024: {
                            // 		items: 2,
                            // 		nav: true
                            // 		// loop: false
                            // 	},
                            // 	1280: {
                            // 		items: 6,
                            // 		nav: true
                            // 		// loop: false
                            // 	},
                            // 	1366: {
                            // 		items: 6,
                            // 		nav: true
                            // 		// loop: true
                            // 	},
                            // 	1440: {
                            // 		items: 6,
                            // 		nav: true
                            // 		// loop: true
                            // 	},
                            // 	1441: {
                            // 		items: 6,
                            // 		nav: true
                            // 		// loop: true
                            // 	}
                            // }
                        });
                        $(".play").on("click", function () {
                            owl.trigger("play.owl.autoplay", [1000]);
                        });
                        $(".stop").on("click", function () {
                            owl.trigger("stop.owl.autoplay");
                        });
                        $(".customNextBtn").click(function () {
                            owl.trigger("next.owl.carousel");
                        });
                        // Go to the previous item
                        $(".customPrevBtn").click(function () {
                            // With optional speed parameter
                            // Parameters has to be in square bracket '[]'
                            owl.trigger("prev.owl.carousel", [300]);
                        });
                    }, timer);
                }
                /* eslint-enable */
            },
            deep: true
        },
        buildItemId() {
            this.calculatePricing(this.active_gender_index);
        },
        allDecorationColors: {
            handler(newColors, oldColors) {
                // When design colors change, update full color locations if they exist
                if (
                    newColors &&
                    this.genderGroups &&
                    this.genderGroups[this.active_gender_index]
                ) {
                    this.genderGroups[
                        this.active_gender_index
                    ].imprint_locations.forEach((location, index) => {
                        // Check if this location has design colors
                        if (
                            location.location &&
                            newColors[location.location.toLowerCase()]
                        ) {
                            let decorationColors =
                                newColors[location.location.toLowerCase()] ||
                                [];

                            // If full color service and more than 1 color, set to full_color
                            if (
                                this.activeDecorationService &&
                                this.activeDecorationService.is_full_color ===
                                    true
                            ) {
                                if (decorationColors.length > 1) {
                                    // Set to full color if more than 1 color
                                    location.no_of_color = "full_color";
                                    location.is_full_color = true;
                                    location.full_color_count =
                                        decorationColors.length;
                                    this.extractDesignColorsForLocation(
                                        location,
                                        index
                                    );
                                } else if (decorationColors.length === 1) {
                                    // If only 1 color, set to 1
                                    location.no_of_color = 1;
                                    location.is_full_color = false;
                                    this.extractDesignColorsForLocation(
                                        location,
                                        index
                                    );
                                }
                            } else if (
                                location.is_full_color === true ||
                                location.no_of_color === "full_color"
                            ) {
                                // Already in full color mode, just update colors
                                this.extractDesignColorsForLocation(
                                    location,
                                    index
                                );
                            }
                        }
                    });
                }
            },
            deep: true
        }
    },
    beforeMount() {
        this.picked_color = this.getActiveColorData();

        /* eslint-disable */
        this.genderGroups[
            this.active_gender_index
        ].imprint_locations[0].collapse = true;

        /* eslint-enable */
        this.getAllMarkupTiers(
            this.product.decoration_type,
            this.product.decoration_price_template
        );
    },
    mounted() {
        /* eslint-disable */
        let pathSegments = this.$route.path.split("/");
        let lastSegment = pathSegments.filter(Boolean).pop(); // Removes empty strings
        if (lastSegment == "build") {
            this.page_status = 1;
        }
        if (this.page_status == 0) {
            let firstIndex = this.genderGroups[
                this.active_gender_index
            ].imprint_locations.findIndex((location) => {
                return location.is_selected;
            });
            let element = document.getElementById(
                "collapseColors" + firstIndex
            );
            setTimeout(() => {
                $("#collapseid" + firstIndex).click();
                element.classList.remove("show");
                this.page_status = 1;
            }, 1000);
        }
        /* eslint-enable */
        let vendorColor = this.vendorColors.find(
            (vendorColor) => vendorColor.color_value == "#GGGGGG"
        );
        /* eslint-disable */
        if (typeof vendorColor == "undefined")
            this.vendorColors.push({
                color_id: 0,
                color_name: "Mix Color",
                color_pms: "Non Standard",
                decor_upcharge: 0,
                color_value: "#GGGGGG",
                swatches: "",
                category: "Non Standard",
                shades: []
            });
        this.prepareDecorationPrices();

        // Initialize full color locations with design colors if available
        this.genderGroups[this.active_gender_index].imprint_locations.forEach(
            (location, index) => {
                if (
                    location.is_full_color === true ||
                    location.no_of_color === "full_color"
                ) {
                    // Initialize full_color_count if not set
                    if (!location.full_color_count) {
                        location.full_color_count = 1;
                    }
                    // Extract colors from design if available
                    this.extractDesignColorsForLocation(location, index);
                }
            }
        );

        if (this.genderGroups[this.active_gender_index].colors.length > 3) {
            let timer = 1000;
            setTimeout(() => {
                let owl = $(".ink-color-slider").owlCarousel({
                    loop: false,
                    // stagePadding: 0,
                    autoWidth: false,
                    margin: 0,
                    items: 3,
                    autoplay: false,
                    autoplayTimeout: 4000,
                    autoplayHoverPause: false,
                    responsiveClass: true,
                    navigation: false,
                    dots: false
                    // responsive: {
                    // 	0: {
                    // 		items: 6,
                    // 		nav: true
                    // 	},
                    // 	360: {
                    // 		items: 6,
                    // 		nav: true
                    // 	},
                    // 	600: {
                    // 		items: 5,
                    // 		nav: true
                    // 	},
                    // 	767: {
                    // 		items: 6,
                    // 		nav: true
                    // 		// loop: true,
                    // 	},
                    // 	1024: {
                    // 		items: 2,
                    // 		nav: true
                    // 		// loop: false
                    // 	},
                    // 	1280: {
                    // 		items: 6,
                    // 		nav: true
                    // 		// loop: false
                    // 	},
                    // 	1366: {
                    // 		items: 6,
                    // 		nav: true
                    // 		// loop: true
                    // 	},
                    // 	1440: {
                    // 		items: 6,
                    // 		nav: true
                    // 		// loop: true
                    // 	},
                    // 	1441: {
                    // 		items: 6,
                    // 		nav: true
                    // 		// loop: true
                    // 	}
                    // }
                });
                $(".play").on("click", function () {
                    owl.trigger("play.owl.autoplay", [1000]);
                });
                $(".stop").on("click", function () {
                    owl.trigger("stop.owl.autoplay");
                });
                $(".customNextBtn").click(function () {
                    owl.trigger("next.owl.carousel");
                });
                // Go to the previous item
                $(".customPrevBtn").click(function () {
                    // With optional speed parameter
                    // Parameters has to be in square bracket '[]'
                    owl.trigger("prev.owl.carousel", [300]);
                });
            }, timer);
        }
        /* eslint-enable */
        this.calcImprintLocationByGender();
        // storing the color, no.of color and total cost for reset BY jinendra
        this.originalImprintLocations = this.genderGroups[
            this.active_gender_index
        ].imprint_locations.map((loc) => ({
            no_of_color: loc.no_of_color,
            is_selected: loc.is_selected
        }));
        this.originalTotalCost =
            this.genderGroups[this.active_gender_index].total_cost;
    },
    methods: {
        // Prepare color-size combinations array for price breakdown
        getColorSizeCombinations(gender) {
            if (!gender || !gender.colors || !Array.isArray(gender.colors)) {
                return [];
            }

            const combinations = [];

            gender.colors.forEach((color) => {
                if (!color.unique_sizes || !Array.isArray(color.unique_sizes)) {
                    return;
                }

                color.unique_sizes.forEach((size) => {
                    // Only include sizes with quantity > 0
                    if (size.quantity && parseInt(size.quantity) > 0) {
                        // Extract only size abbreviation (XS, S, M, L, XL, etc.)
                        let sizeAbbr = "N/A";
                        if (size.size_name) {
                            sizeAbbr = size.size_name;
                        } else if (size.size) {
                            // If size contains full product name, extract last word (size abbreviation)
                            const sizeParts = size.size.trim().split(/\s+/);
                            sizeAbbr = sizeParts[sizeParts.length - 1];
                        } else if (size.name) {
                            // If name contains full product name, extract last word (size abbreviation)
                            const nameParts = size.name.trim().split(/\s+/);
                            sizeAbbr = nameParts[nameParts.length - 1];
                        }

                        // Get color value and ensure it has # prefix
                        // Try multiple possible property names: color_value, hex, hash
                        let colorValue =
                            color.color_value || color.hex || color.hash || "";
                        if (colorValue && !colorValue.startsWith("#")) {
                            colorValue = "#" + colorValue;
                        }
                        if (!colorValue) {
                            colorValue = "#cccccc";
                        }

                        combinations.push({
                            color_id: color.id || color.color_id,
                            color_name:
                                color.name || color.color_name || "Color",
                            color_value: colorValue,
                            hex: colorValue,
                            size: sizeAbbr,
                            quantity: parseInt(size.quantity) || 0,
                            cost: parseFloat(size.cost) || 0,
                            total_cost: parseFloat(size.total_cost) || 0
                        });
                    }
                });
            });

            return combinations;
        },
        // New function to reset imprint colors and costs by jinendra
        resetImprintColors() {
            const gender = this.genderGroups[this.active_gender_index];
            if (!gender || !this.originalImprintLocations.length) return;

            let activeImprintLocation = null;

            gender.imprint_locations.forEach((imprintLocation, index) => {
                const original = this.originalImprintLocations[index];
                if (!original) return;

                // Empty the color array
                imprintLocation.colors = Array(original.no_of_color).fill({
                    color: null
                });

                // Restore number of color boxes and selection state
                imprintLocation.no_of_color = original.no_of_color;
                imprintLocation.is_selected = original.is_selected;

                // Check if the front side is selected
                if (
                    imprintLocation.location === "Front" &&
                    imprintLocation.is_selected
                ) {
                    activeImprintLocation = imprintLocation;
                }
            });

            // If the front side is not selected, find the first selected imprint location
            if (!activeImprintLocation) {
                activeImprintLocation = gender.imprint_locations.find(
                    (loc) => loc.is_selected
                );
            }

            // Same for variations
            gender.colors.forEach((fabricColor) => {
                if (!fabricColor.imprint_locations) return;

                fabricColor.imprint_locations.forEach((loc, index) => {
                    const original = this.originalImprintLocations[index];
                    if (!original) return;

                    loc.colors = Array(original.no_of_color).fill({
                        color: null
                    });
                    loc.no_of_color = original.no_of_color;
                    loc.is_selected = original.is_selected;
                });
            });

            // Update the active imprint location to display
            if (activeImprintLocation) {
                this.updatePrintAreas(
                    gender.imprint_locations.indexOf(activeImprintLocation)
                );
            }

            gender.total_cost = this.originalTotalCost;
            this.$forceUpdate();
        },
        updateAccordianFlip(index) {
            /* eslint-disable */
            if (this.index_prev != index) $("#collapseid" + index).click();
            /* eslint-enable */
        },
        getSelectedColorImprintLocations() {
            return this.genderGroups[this.active_gender_index].colors[
                this.activeColorIndex
            ].imprint_locations;
        },

        getLocationColor(
            imprintLocationIndex,
            imprintColorIndex,
            fabricColorIndex
        ) {
            return this.genderGroups[this.active_gender_index].colors[
                fabricColorIndex
            ].imprint_locations[imprintLocationIndex].colors[imprintColorIndex]
                .color;
        },

        getGenderImprintLocations() {
            // Return original locations array for template binding
            // Colors will be merged when needed for PCNA breakdown via getGenderImprintLocationsWithColors()
            return this.genderGroups[this.active_gender_index]
                .imprint_locations;
        },

        // Separate method for PCNA breakdown that includes colors
        getGenderImprintLocationsWithColors() {
            // For PCNA breakdown, we need to include colors from colors' imprint_locations
            // to ensure non_standard_fee is properly available
            const locations =
                this.genderGroups[this.active_gender_index].imprint_locations;

            // Get colors from the first available color's imprint_locations (all colors should have same structure)
            if (
                this.genderGroups[this.active_gender_index].colors &&
                this.genderGroups[this.active_gender_index].colors.length > 0
            ) {
                // Try to get colors from active color first, otherwise use first color
                const colorIndex =
                    this.activeColorIndex >= 0 ? this.activeColorIndex : 0;
                const colorData =
                    this.genderGroups[this.active_gender_index].colors[
                        colorIndex
                    ];

                if (
                    colorData &&
                    colorData.imprint_locations &&
                    Array.isArray(colorData.imprint_locations)
                ) {
                    // Create a new array with merged colors data
                    return locations.map((location, index) => {
                        const locationCopy = { ...location };
                        // Get colors from color's imprint_locations if available
                        if (
                            colorData.imprint_locations[index] &&
                            colorData.imprint_locations[index].colors &&
                            Array.isArray(
                                colorData.imprint_locations[index].colors
                            )
                        ) {
                            locationCopy.colors =
                                colorData.imprint_locations[index].colors;
                        }
                        return locationCopy;
                    });
                }
            }

            return locations;
        },

        getActiveColorData() {
            return this.genderGroups[this.active_gender_index].colors[
                this.activeColorIndex
            ];
        },

        getColorTotalCost() {
            return this.icPriceFormat(
                this.genderGroups[this.active_gender_index].colors[
                    this.activeColorIndex
                ].total_cost_gender_wise
            );
        },

        getColorTotalQuantity() {
            return this.genderGroups[this.active_gender_index].colors[
                this.activeColorIndex
            ].total_qty_gender_wise;
        },

        getPCNAMixColorCount() {
            // For PCNA, get mix color count from totalNonStandardColors prop or calculate from allDecorationColors
            if (
                this.totalNonStandardColors &&
                Array.isArray(this.totalNonStandardColors) &&
                this.totalNonStandardColors.length > 0
            ) {
                return this.totalNonStandardColors.length;
            }

            // Fallback: calculate from allDecorationColors (non-standard colors not in vendorColors)
            if (
                this.allDecorationColors &&
                this.vendorColors &&
                Array.isArray(this.vendorColors)
            ) {
                let allColors = [];
                for (const [flip, colorHexCodes] of Object.entries(
                    this.allDecorationColors
                )) {
                    if (colorHexCodes && Array.isArray(colorHexCodes)) {
                        allColors = allColors.concat(colorHexCodes);
                    }
                }

                // Filter non-standard colors (colors not in vendorColors)
                if (allColors.length > 0) {
                    const nonStandardColors = allColors.filter((hexCode) => {
                        if (!hexCode) return false;
                        const hex =
                            typeof hexCode === "string"
                                ? hexCode.toLowerCase()
                                : hexCode.hex
                                ? hexCode.hex.toLowerCase()
                                : "";
                        const vendorColor = this.vendorColors.find(
                            (color) =>
                                color.color_value &&
                                color.color_value.toLowerCase() === hex
                        );
                        return !vendorColor; // Non-standard if not found in vendor colors
                    });
                    // Remove duplicates
                    const uniqueColors = [...new Set(nonStandardColors)];
                    return uniqueColors.length;
                }
            }

            return 0;
        },

        getPCNAFeePerColor() {
            // Try to get fee per color from props first
            if (
                this.nonStandardFeePerColor &&
                parseFloat(this.nonStandardFeePerColor) > 0
            ) {
                return parseFloat(this.nonStandardFeePerColor);
            }

            // Fallback: try to get from parent's adminOptions
            if (
                this.$parent &&
                this.$parent.adminOptions &&
                Array.isArray(this.$parent.adminOptions)
            ) {
                const activeService = this.activeDecorationService;
                const serviceName = activeService
                    ? (activeService.name || "").toLowerCase()
                    : "";
                const isEmbroideryService =
                    serviceName.includes("embroidery") ||
                    serviceName.includes("emb");
                const isPrintService = serviceName.includes("print");

                let optionKey = null;
                if (isEmbroideryService) {
                    optionKey = "non_standard_color_fees_emb";
                } else if (isPrintService) {
                    optionKey = "non_standard_color_fees";
                }
                // If neither embroidery nor print, optionKey remains null (no fee)

                if (optionKey) {
                    let feeObj = this.$parent.adminOptions.find(
                        (option) => option.option_key === optionKey
                    );
                    if (feeObj && feeObj.option_value) {
                        return parseFloat(feeObj.option_value) || 0;
                    }
                }
            }

            return 0;
        },

        // Get Custom Color Fee from VendorFees (using ecomm_display for matching)
        getColorMixFeeFromVendorServices(decorationType, serviceName) {
            // Use VendorFees from product data instead of otherServices prop
            const vendorFees =
                this.product && this.product.VendorFees
                    ? this.product.VendorFees
                    : [];

            if (
                !vendorFees ||
                !Array.isArray(vendorFees) ||
                vendorFees.length === 0
            ) {
                return null;
            }

            // Determine which service to use based on decoration type or service name
            let targetService = null;

            if (decorationType == 1) {
                // Screen Print - use Custom Ink Mix Fee
                targetService = vendorFees.find(
                    (service) =>
                        service.type === "custom_ink_mix" ||
                        (service.ecomm_display &&
                            service.ecomm_display
                                .toLowerCase()
                                .includes("ink mix fee"))
                );
            } else if (decorationType == 2) {
                // Embroidery - use Thread Fee
                targetService = vendorFees.find(
                    (service) =>
                        service.type === "thread_fee" ||
                        (service.ecomm_display &&
                            service.ecomm_display
                                .toLowerCase()
                                .includes("thread mix fee"))
                );
            } else {
                // For PCNA (decoration_type 0), check service name for "print" or "embroidery"
                const serviceNameLower = serviceName
                    ? serviceName.toLowerCase()
                    : "";
                const isEmbroidery =
                    serviceNameLower.includes("embroidery") ||
                    serviceNameLower.includes("emb");
                const isPrint = serviceNameLower.includes("print");

                if (isEmbroidery) {
                    // Embroidery service = Thread Mix Fee
                    targetService = vendorFees.find(
                        (service) =>
                            service.type === "thread_fee" ||
                            (service.ecomm_display &&
                                service.ecomm_display
                                    .toLowerCase()
                                    .includes("thread mix fee"))
                    );
                } else if (isPrint) {
                    // Print service = Ink Mix Fee
                    targetService = vendorFees.find(
                        (service) =>
                            service.type === "custom_ink_mix" ||
                            (service.ecomm_display &&
                                service.ecomm_display
                                    .toLowerCase()
                                    .includes("ink mix fee"))
                    );
                }
                // If neither embroidery nor print, targetService remains null (no fee)
            }

            if (targetService && targetService.retail_cost) {
                return parseFloat(targetService.retail_cost) || 0;
            }

            return null;
        },

        // Get Name Fee from VendorFees (using ecomm_display for matching)
        getNameFeeFromVendorServices() {
            // Use VendorFees from product data instead of otherServices prop
            const vendorFees =
                this.product && this.product.VendorFees
                    ? this.product.VendorFees
                    : [];

            if (
                !vendorFees ||
                !Array.isArray(vendorFees) ||
                vendorFees.length === 0
            ) {
                return null;
            }

            // Find by type first, then fallback to ecomm_display matching
            const nameService = vendorFees.find(
                (service) =>
                    service.type === "name" ||
                    (service.ecomm_display &&
                        service.ecomm_display.toLowerCase().includes("name"))
            );

            if (nameService && nameService.retail_cost) {
                return parseFloat(nameService.retail_cost) || 0;
            }

            return null;
        },

        // Get Number Fee from VendorFees (using ecomm_display for matching)
        getNumberFeeFromVendorServices() {
            // Use VendorFees from product data instead of otherServices prop
            const vendorFees =
                this.product && this.product.VendorFees
                    ? this.product.VendorFees
                    : [];

            if (
                !vendorFees ||
                !Array.isArray(vendorFees) ||
                vendorFees.length === 0
            ) {
                return null;
            }

            // Find by type first, then fallback to ecomm_display matching
            const numberService = vendorFees.find(
                (service) =>
                    service.type === "number" ||
                    (service.ecomm_display &&
                        service.ecomm_display.toLowerCase().includes("number"))
            );

            if (numberService && numberService.retail_cost) {
                return parseFloat(numberService.retail_cost) || 0;
            }

            return null;
        },

        // Get unique non-standard color count for design studio
        getUniqueNonStandardColorCount() {
            if (
                !this.allDecorationColors ||
                !this.vendorColors ||
                !Array.isArray(this.vendorColors)
            ) {
                return 0;
            }

            let allColors = [];
            for (const [flip, colorHexCodes] of Object.entries(
                this.allDecorationColors
            )) {
                if (colorHexCodes && Array.isArray(colorHexCodes)) {
                    allColors = allColors.concat(colorHexCodes);
                }
            }

            if (allColors.length === 0) {
                return 0;
            }

            // Filter non-standard colors (colors not in vendorColors)
            const nonStandardColors = allColors.filter((hexCode) => {
                if (!hexCode) return false;
                const hex =
                    typeof hexCode === "string"
                        ? hexCode.toLowerCase()
                        : hexCode.hex
                        ? hexCode.hex.toLowerCase()
                        : "";
                const vendorColor = this.vendorColors.find(
                    (color) =>
                        color.color_value &&
                        color.color_value.toLowerCase() === hex
                );
                return !vendorColor; // Non-standard if not found in vendor colors
            });

            // Remove duplicates and return count
            const uniqueColors = [...new Set(nonStandardColors)];
            return uniqueColors.length;
        },

        // Check if front or back has decorations
        hasFrontOrBackDecoration(genderIndex) {
            if (
                !this.genderGroups[genderIndex] ||
                !this.genderGroups[genderIndex].imprint_locations
            ) {
                return { hasFront: false, hasBack: false };
            }

            const imprintLocations =
                this.genderGroups[genderIndex].imprint_locations;
            const hasFront = imprintLocations.some(
                (loc) =>
                    loc.is_selected &&
                    loc.location &&
                    loc.location.toLowerCase() === "front"
            );
            const hasBack = imprintLocations.some(
                (loc) =>
                    loc.is_selected &&
                    loc.location &&
                    loc.location.toLowerCase() === "back"
            );

            return { hasFront, hasBack };
        },

        // Count names and numbers from name_and_number_json for all colors in gender
        countNamesAndNumbers(genderIndex) {
            if (
                !this.genderGroups[genderIndex] ||
                !this.genderGroups[genderIndex].colors
            ) {
                return { nameCount: 0, numberCount: 0 };
            }

            let nameCount = 0;
            let numberCount = 0;

            this.genderGroups[genderIndex].colors.forEach((color) => {
                if (
                    color.name_and_number_json &&
                    Array.isArray(color.name_and_number_json)
                ) {
                    color.name_and_number_json.forEach((nn) => {
                        if (nn.name && nn.name.trim() !== "") {
                            nameCount++;
                        }
                        if (nn.number && nn.number.toString().trim() !== "") {
                            numberCount++;
                        }
                    });
                }
            });

            return { nameCount, numberCount };
        },

        // Count names and numbers per location (front/back) based on selected_name_number
        // Count each name/number only for the location where it's selected
        // This matches the old calcNameNumberFees logic where each item is counted per location

        countNamesAndNumbersByLocation(genderIndex) {
            if (
                !this.genderGroups[genderIndex] ||
                !this.genderGroups[genderIndex].colors
            ) {
                return {
                    frontNameCount: 0,
                    backNameCount: 0,
                    frontNumberCount: 0,
                    backNumberCount: 0
                };
            }

            let frontNameCount = 0;
            let backNameCount = 0;
            let frontNumberCount = 0;
            let backNumberCount = 0;

            this.genderGroups[genderIndex].colors.forEach((color) => {
                // Only proceed if name_and_number_json exists and has entries
                if (
                    !color.name_and_number_json ||
                    !Array.isArray(color.name_and_number_json) ||
                    color.name_and_number_json.length === 0
                ) {
                    return;
                }

                // Filter to only items that have actual non-empty names or numbers
                // This ensures we only count when names/numbers are actually added, not just when decoration is added
                const nameAndNumbers = color.name_and_number_json.filter(
                    (nn) => {
                        const hasName =
                            nn.name &&
                            typeof nn.name === "string" &&
                            nn.name.trim() !== "";
                        const hasNumber =
                            nn.number !== null &&
                            nn.number !== undefined &&
                            nn.number.toString().trim() !== "";
                        return hasName || hasNumber;
                    }
                );

                // If no valid names/numbers found, don't count anything
                if (nameAndNumbers.length === 0) {
                    return;
                }

                // Check if names/numbers are selected for front/back
                const selectedNameNumber = color.selected_name_number || {};
                const frontSelected = selectedNameNumber.front || {};
                const backSelected = selectedNameNumber.back || {};

                // Count each item separately for each location where it's selected
                nameAndNumbers.forEach((nn) => {
                    // Count names for back location (names are only on back)
                    // Only count if name is non-empty AND back.name is selected
                    if (
                        nn.name &&
                        typeof nn.name === "string" &&
                        nn.name.trim() !== "" &&
                        backSelected.name === true
                    ) {
                        backNameCount++;
                    }

                    // Count numbers per location - same logic as old calcNameNumberFees
                    // Each number is counted for each location where it's selected
                    // This means if both front and back have numbers selected, the same numbers count for both
                    // Only count if number is non-empty
                    if (
                        nn.number !== null &&
                        nn.number !== undefined &&
                        nn.number.toString().trim() !== ""
                    ) {
                        // Count for front if front.number is selected
                        if (frontSelected.number === true) {
                            frontNumberCount++;
                        }
                        // Count for back if back.number is selected
                        if (backSelected.number === true) {
                            backNumberCount++;
                        }
                    }
                });
            });

            return {
                frontNameCount,
                backNameCount,
                frontNumberCount,
                backNumberCount
            };
        },

        selectImprintLocations(index) {
            // if (this.disable_imprint_locations) {
            //     return;
            // }
            let imprint_locations = this.getGenderImprintLocations();
            let no_of_location = 0;
            let previous_index = "";
            imprint_locations.forEach((location, key) => {
                if (location.is_selected) {
                    no_of_location++;
                    previous_index = key;
                }
            });
            // Maintain only on selection in imprint locations
            if (no_of_location == 1 && previous_index == index) {
                return true;
            }

            // Get the new selection state before toggling
            const newSelectionState = !imprint_locations[index].is_selected;

            // Update main imprint_locations array
            if (imprint_locations[index].is_selected) {
                imprint_locations[index].no_of_color = null;
                imprint_locations[index].colors = [];
            }
            imprint_locations[index].is_selected = newSelectionState;

            // Update all colors' imprint_locations arrays
            let selectedColors =
                this.genderGroups[this.active_gender_index].colors;
            selectedColors.forEach((color) => {
                // Use the new selection state consistently
                if (newSelectionState) {
                    // If selecting, clear colors if they exist
                    if (
                        color.imprint_locations[index].colors &&
                        color.imprint_locations[index].colors.length > 0
                    ) {
                        color.imprint_locations[index].no_of_color = null;
                        color.imprint_locations[index].colors = [];
                    }
                } else {
                    // If deselecting, clear colors
                    color.imprint_locations[index].no_of_color = null;
                    color.imprint_locations[index].colors = [];
                }
                color.imprint_locations[index].is_selected = newSelectionState;
            });

            this.updatePrintAreas(index);
            this.calculatePricing(this.active_gender_index);
            setTimeout(() => {
                /* eslint-disable */
                $("#collapseid" + index).click();
                /* eslint-enable */
            }, 1000);
            this.$forceUpdate();
        },

        selectNumberOfColors(location, count) {
            let locationIndex = this.genderGroups[
                this.active_gender_index
            ].imprint_locations.findIndex(
                (locat) => locat.location == location.location
            );

            // Handle "Full color" selection
            if (count === "full_color" || count === "Full color") {
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].no_of_color = "full_color";
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].is_full_color = true;

                // Initialize with default color count of 1 for full color
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].full_color_count = 1;

                // Extract colors from design if available
                let designColors = [];
                if (this.allDecorationColors && location.location) {
                    let locationKey = location.location.toLowerCase();
                    let decorationColors =
                        this.allDecorationColors[locationKey] || [];

                    if (
                        decorationColors &&
                        Array.isArray(decorationColors) &&
                        decorationColors.length > 0
                    ) {
                        decorationColors.forEach((colorHex) => {
                            // Find vendor color or create non-standard color
                            let vendorColor = this.vendorColors.find(
                                (vc) =>
                                    vc.color_value &&
                                    vc.color_value.toLowerCase() ===
                                        colorHex.toLowerCase()
                            );

                            if (vendorColor) {
                                designColors.push({
                                    color: vendorColor,
                                    color_cost: 0.0,
                                    cost_cost: 0.0,
                                    cost_sum_added: false
                                });
                            } else {
                                // Non-standard color
                                designColors.push({
                                    color: {
                                        color_id: 0,
                                        color_name: "Mix Color",
                                        color_pms: "Non Standard",
                                        decor_upcharge: 0,
                                        color_value: colorHex || "#GGGGGG",
                                        swatches: "",
                                        category: "Non Standard",
                                        shades: []
                                    },
                                    color_cost: 0.0,
                                    cost_cost: 0.0,
                                    cost_sum_added: false
                                });
                            }
                        });
                    }
                }

                // If design colors found, use them; otherwise initialize with 1 empty slot
                if (designColors.length > 0) {
                    this.genderGroups[
                        this.active_gender_index
                    ].imprint_locations[locationIndex].colors = designColors;
                    this.genderGroups[
                        this.active_gender_index
                    ].imprint_locations[locationIndex].full_color_count =
                        designColors.length;
                } else {
                    // Initialize with 1 empty color slot
                    this.genderGroups[
                        this.active_gender_index
                    ].imprint_locations[locationIndex].colors = [
                        {
                            color: null,
                            color_cost: 0.0,
                            cost_cost: 0.0,
                            cost_sum_added: false
                        }
                    ];
                }

                let selectedColors =
                    this.genderGroups[this.active_gender_index].colors;
                selectedColors.forEach((color) => {
                    // Copy colors structure to all fabric colors
                    if (designColors.length > 0) {
                        color.imprint_locations[locationIndex].colors =
                            JSON.parse(JSON.stringify(designColors));
                    } else {
                        color.imprint_locations[locationIndex].colors = [
                            {
                                color: null,
                                color_cost: 0.0,
                                cost_cost: 0.0,
                                cost_sum_added: false
                            }
                        ];
                    }
                    color.imprint_locations[locationIndex].no_of_color =
                        "full_color";
                    color.imprint_locations[locationIndex].is_full_color = true;
                    color.imprint_locations[locationIndex].full_color_count =
                        this.genderGroups[this.active_gender_index]
                            .imprint_locations[locationIndex]
                            .full_color_count || 1;
                });
            } else {
                // Normal color count selection
                let no_of_colors = parseInt(count) || 0;
                let colors = [];
                for (let i = 0; i < no_of_colors; i++) {
                    colors.push({
                        color: null,
                        color_cost: 0.0,
                        cost_cost: 0.0,
                        cost_sum_added: false
                    });
                }
                /* eslint-disable */
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].colors = colors;
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].no_of_color = parseInt(count) || null;
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].is_full_color = false;

                let selectedColors =
                    this.genderGroups[this.active_gender_index].colors;
                selectedColors.forEach((color) => {
                    color.imprint_locations[locationIndex].colors = colors;
                    color.imprint_locations[locationIndex].no_of_color =
                        parseInt(count) || null;
                    color.imprint_locations[
                        locationIndex
                    ].is_full_color = false;
                });
            }

            this.calculatePricing(this.active_gender_index);
            if (this.genderGroups[this.active_gender_index].colors.length > 3) {
                let timer = 1000;
                setTimeout(() => {
                    let owl = $(".ink-color-slider").owlCarousel({
                        loop: false,
                        autoWidth: false,
                        margin: 0,
                        items: 3,
                        autoplay: false,
                        autoplayTimeout: 4000,
                        autoplayHoverPause: false,
                        responsiveClass: true,
                        navigation: false,
                        dots: false
                    });
                    $(".play").on("click", function () {
                        owl.trigger("play.owl.autoplay", [1000]);
                    });
                    $(".stop").on("click", function () {
                        owl.trigger("stop.owl.autoplay");
                    });
                    $(".customNextBtn").click(function () {
                        owl.trigger("next.owl.carousel");
                    });
                    // Go to the previous item
                    $(".customPrevBtn").click(function () {
                        // With optional speed parameter
                        // Parameters has to be in square bracket '[]'
                        owl.trigger("prev.owl.carousel", [300]);
                    });
                }, timer);
            }
            /* eslint-enable */
        },

        selectVendorColors(
            imprintColorObj,
            imprintColorIndex,
            imprintLocationIndex,
            fabricColorIndex
        ) {
            let fabricColors =
                this.genderGroups[this.active_gender_index].colors;
            let fabricColor = fabricColors[fabricColorIndex];
            let imprint_color =
                fabricColor.imprint_locations[imprintLocationIndex].colors[
                    imprintColorIndex
                ];
            if (imprintColorObj) {
                // Create a copy of the color object to avoid mutating the original
                let colorObj = { ...imprintColorObj };

                // If it's a custom color (color_id == 0), set non_standard_fee based on decoration type
                if (colorObj.color_id == 0) {
                    let nonStandardFee = 0;
                    const decorationType =
                        this.activeDecorationService &&
                        this.activeDecorationService.master_service
                            ? this.activeDecorationService.master_service
                                  .decoration_type
                            : this.activeDecorationService &&
                              this.activeDecorationService.decoration_type
                            ? this.activeDecorationService.decoration_type
                            : null;
                    const serviceName = this.activeDecorationService
                        ? (
                              this.activeDecorationService.name || ""
                          ).toLowerCase()
                        : "";

                    if (decorationType == 0) {
                        // PCNA - Get fee per color for PCNA
                        let feePerColor = this.getPCNAFeePerColor();
                        if (feePerColor > 0) {
                            nonStandardFee = feePerColor;
                        }
                    } else if (decorationType == 1 || decorationType == 2) {
                        // Print or Embroidery - Get from VendorServices
                        let colorMixFeePerColor =
                            this.getColorMixFeeFromVendorServices(
                                decorationType,
                                serviceName
                            );
                        if (
                            colorMixFeePerColor !== null &&
                            colorMixFeePerColor > 0
                        ) {
                            nonStandardFee = colorMixFeePerColor;
                        }
                    }

                    if (nonStandardFee > 0) {
                        colorObj.non_standard_fee = nonStandardFee;
                    }
                }

                imprint_color.color = colorObj;
                imprint_color.decor_upcharge = {
                    cost_added: true,
                    color_id: colorObj.color_id,
                    color_cost: 0,
                    cost_cost: 0
                };
            } else {
                imprint_color.color = null;
                imprint_color.decor_upcharge = null;
            }

            // Trigger pricing calculation to update display
            this.calculatePricing(this.active_gender_index);
        },

        updateFullColorCount(location, count) {
            let locationIndex = this.genderGroups[
                this.active_gender_index
            ].imprint_locations.findIndex(
                (locat) => locat.location == location.location
            );

            let colorCount = parseInt(count) || 1;
            if (colorCount < 1) colorCount = 1;

            // Update full_color_count
            this.genderGroups[this.active_gender_index].imprint_locations[
                locationIndex
            ].full_color_count = colorCount;

            // Adjust colors array based on new count
            let currentColors =
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].colors || [];

            if (colorCount > currentColors.length) {
                // Add more empty color slots
                for (let i = currentColors.length; i < colorCount; i++) {
                    currentColors.push({
                        color: null,
                        color_cost: 0.0,
                        cost_cost: 0.0,
                        cost_sum_added: false
                    });
                }
            } else if (colorCount < currentColors.length) {
                // Remove extra color slots
                currentColors = currentColors.slice(0, colorCount);
            }

            this.genderGroups[this.active_gender_index].imprint_locations[
                locationIndex
            ].colors = currentColors;

            // Update for all fabric colors
            let selectedColors =
                this.genderGroups[this.active_gender_index].colors;
            selectedColors.forEach((color) => {
                // Adjust colors array for this fabric color
                let fabricColors =
                    color.imprint_locations[locationIndex].colors || [];

                if (colorCount > fabricColors.length) {
                    for (let i = fabricColors.length; i < colorCount; i++) {
                        fabricColors.push({
                            color: null,
                            color_cost: 0.0,
                            cost_cost: 0.0,
                            cost_sum_added: false
                        });
                    }
                } else if (colorCount < fabricColors.length) {
                    fabricColors = fabricColors.slice(0, colorCount);
                }

                color.imprint_locations[locationIndex].colors = fabricColors;
                color.imprint_locations[locationIndex].full_color_count =
                    colorCount;
            });

            this.$forceUpdate();
        },

        extractDesignColorsForLocation(location, locationIndex) {
            // Extract colors from design for this location
            let designColors = [];
            if (this.allDecorationColors && location.location) {
                let locationKey = location.location.toLowerCase();
                let decorationColors =
                    this.allDecorationColors[locationKey] || [];

                if (
                    decorationColors &&
                    Array.isArray(decorationColors) &&
                    decorationColors.length > 0
                ) {
                    decorationColors.forEach((colorHex) => {
                        // Find vendor color or create non-standard color
                        let vendorColor = this.vendorColors.find(
                            (vc) =>
                                vc.color_value &&
                                vc.color_value.toLowerCase() ===
                                    colorHex.toLowerCase()
                        );

                        if (vendorColor) {
                            designColors.push({
                                color: vendorColor,
                                color_cost: 0.0,
                                cost_cost: 0.0,
                                cost_sum_added: false
                            });
                        } else {
                            // Non-standard color - get non_standard_fee
                            let nonStandardFee = 0;
                            const decorationType =
                                this.activeDecorationService &&
                                this.activeDecorationService.master_service
                                    ? this.activeDecorationService
                                          .master_service.decoration_type
                                    : this.activeDecorationService &&
                                      this.activeDecorationService
                                          .decoration_type
                                    ? this.activeDecorationService
                                          .decoration_type
                                    : 1;
                            const serviceName = this.activeDecorationService
                                ? (
                                      this.activeDecorationService.name || ""
                                  ).toLowerCase()
                                : "";

                            // Get custom color fee from VendorServices
                            let colorMixFeePerColor =
                                this.getColorMixFeeFromVendorServices(
                                    decorationType,
                                    serviceName
                                );
                            if (
                                colorMixFeePerColor !== null &&
                                colorMixFeePerColor > 0
                            ) {
                                nonStandardFee = colorMixFeePerColor;
                            }

                            designColors.push({
                                color: {
                                    color_id: 0,
                                    color_name: "Mix Color",
                                    color_pms: "Non Standard",
                                    non_standard_fee: nonStandardFee,
                                    decor_upcharge: 0,
                                    color_value: colorHex || "#GGGGGG",
                                    swatches: "",
                                    category: "Non Standard",
                                    shades: []
                                },
                                color_cost: 0.0,
                                cost_cost: 0.0,
                                cost_sum_added: false
                            });
                        }
                    });
                }
            }

            // Update colors if design colors found
            if (designColors.length > 0) {
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].colors = designColors;
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].full_color_count = designColors.length;

                // Update for all fabric colors
                let selectedColors =
                    this.genderGroups[this.active_gender_index].colors;
                selectedColors.forEach((color) => {
                    color.imprint_locations[locationIndex].colors = JSON.parse(
                        JSON.stringify(designColors)
                    );
                    color.imprint_locations[locationIndex].full_color_count =
                        designColors.length;
                });

                this.$forceUpdate();
            }
        },

        calcImprintLocationByGender(masterServicePricing = null) {
            if (!this.activeDecorationService) {
                console.error(
                    "calcImprintLocationByGender: activeDecorationService is missing."
                );
                return { total_colors: 0, totalCalculatedDecorationFee: 0 };
            }

            let total_gender_quantity = this.getTotalItemQuantity(
                this.genderGroups[this.active_gender_index] // Ensure active_gender_index is correct
            );

            let imprint_locations = this.getGenderImprintLocations(); // Ensure this returns the correct locations array for the active gender/color

            let initalLocationIndex = 0; // Tracks 1st, 2nd, etc., SELECTED location
            let decoration_type = this.activeDecorationService.decoration_type;
            let total_colors = 0; // Total colors across selected locations
            let totalCalculatedDecorationFee = 0; // Total run charge

            // Reset fees for all locations first to avoid stale data
            imprint_locations.forEach((location) => {
                location.decoration_fee = 0;
                location.total_decoration_fee = 0;
                location.total_decor_upcharge = 0;
                if (location.colors && Array.isArray(location.colors)) {
                    location.colors.forEach(
                        (color) => (color.total_decor_upcharge = 0)
                    );
                }
            });

            if (decoration_type == 0) {
                //PCNA RUN CHARGE LOGIC
                // If masterServicePricing is not provided, try to get it from activeDecorationService
                if (!masterServicePricing) {
                    if (this.activeDecorationService.master_service) {
                        masterServicePricing =
                            this.activeDecorationService.master_service;
                    } else {
                        console.error(
                            "calcImprintLocationByGender: masterServicePricing is required for decoration_type 0 and could not be found in activeDecorationService.master_service."
                        );
                        return {
                            total_colors: 0,
                            totalCalculatedDecorationFee: 0
                        };
                    }
                }

                imprint_locations.forEach((location, loc_idx) => {
                    if (location.is_selected) {
                        // Check if "Full color" is selected
                        if (
                            location.no_of_color === "full_color" ||
                            location.is_full_color === true
                        ) {
                            // Use full_color value from VendorDecorationService for run charge
                            const fullColorValue = parseFloat(
                                masterServicePricing.full_color || 0
                            );
                            let calculatedFeePerItem = 0;

                            if (initalLocationIndex === 0) {
                                calculatedFeePerItem =
                                    fullColorValue +
                                    parseFloat(
                                        masterServicePricing.location_1st || 0
                                    );
                            } else {
                                calculatedFeePerItem =
                                    fullColorValue +
                                    parseFloat(
                                        masterServicePricing.additional_location ||
                                            0
                                    );
                            }

                            location.decoration_fee = calculatedFeePerItem;
                            location.is_full_color_selected = true;
                            location.full_color_value = fullColorValue;

                            if (total_gender_quantity > 0) {
                                location.total_decoration_fee =
                                    calculatedFeePerItem *
                                    total_gender_quantity;
                                totalCalculatedDecorationFee +=
                                    location.total_decoration_fee;
                            }

                            total_colors += 1; // Count as 1 for full color
                        } else {
                            const color_count =
                                parseInt(location.no_of_color) || 0;
                            total_colors += color_count;

                            if (color_count > 0 && total_gender_quantity > 0) {
                                let calculatedFeePerItem = 0;
                                // Safely parse fees, default to 0
                                const location1stFee = parseFloat(
                                    masterServicePricing.location_1st || 0
                                );
                                const additionalLocationFee = parseFloat(
                                    masterServicePricing.additional_location ||
                                        0
                                );
                                const costPerColor1st = parseFloat(
                                    masterServicePricing.cost_per_color_1st || 0
                                );
                                const costPerColor2ndOrMore = parseFloat(
                                    masterServicePricing.cost_per_color_2ndormore ||
                                        0
                                );

                                if (initalLocationIndex === 0) {
                                    // First selected location
                                    calculatedFeePerItem =
                                        location1stFee +
                                        color_count * costPerColor1st;
                                } else {
                                    // Additional selected location
                                    calculatedFeePerItem =
                                        additionalLocationFee +
                                        color_count * costPerColor2ndOrMore;
                                }

                                location.decoration_fee = calculatedFeePerItem; // Store per-item fee
                                location.total_decoration_fee =
                                    calculatedFeePerItem *
                                    total_gender_quantity; // Calculate total for this location
                                totalCalculatedDecorationFee +=
                                    location.total_decoration_fee; // Accumulate
                            } else {
                                location.decoration_fee = 0;
                                location.total_decoration_fee = 0;
                            }
                            location.is_full_color_selected = false;
                        }
                        initalLocationIndex++; // IMPORTANT: Increment *only* for selected locations
                    }
                });
            } else if (decoration_type == 1) {
                imprint_locations.forEach((location) => {
                    if (location.is_selected) {
                        // Check if "Full color" is selected
                        if (
                            location.no_of_color === "full_color" ||
                            location.is_full_color === true
                        ) {
                            // Use full_color value from decoration service JSON for run charge
                            const fullColorValue = parseFloat(
                                this.activeDecorationService.full_color || 0
                            );
                            let calculatedFeePerItem = 0;

                            if (initalLocationIndex == 0) {
                                // First location - full color value only (no location fee for first location in old logic)
                                calculatedFeePerItem = fullColorValue;
                            } else {
                                // Additional locations - need to get location fee from template
                                let decoration_price = this.getDecorationPrice(
                                    0,
                                    initalLocationIndex
                                );
                                calculatedFeePerItem =
                                    fullColorValue +
                                    parseFloat(decoration_price || 0);
                            }

                            location.decoration_fee = calculatedFeePerItem;
                            location.total_decoration_fee =
                                parseFloat(location.decoration_fee) *
                                total_gender_quantity;
                            location.is_full_color_selected = true;
                            location.full_color_value = fullColorValue;
                            totalCalculatedDecorationFee +=
                                location.total_decoration_fee;
                            total_colors += 1; // Count as 1 for full color
                        } else {
                            let no_of_colors =
                                parseInt(location.no_of_color) || 0;
                            total_colors += no_of_colors;
                            location.total_decor_upcharge = 0;
                            location.colors.forEach((color) => {
                                /* ... upcharge logic ... */
                            });

                            let additional_run_charge_for_location = 0;
                            if (no_of_colors > 0) {
                                let decoration_price_last_color =
                                    this.getDecorationPrice(
                                        no_of_colors - 1,
                                        undefined,
                                        initalLocationIndex > 0
                                    );
                                let decoration_price_first_color =
                                    this.getDecorationPrice(
                                        0,
                                        undefined,
                                        initalLocationIndex > 0
                                    );
                                let additional_color_cost = parseFloat(
                                    (
                                        decoration_price_last_color -
                                        decoration_price_first_color
                                    ).toFixed(2)
                                );

                                if (initalLocationIndex > 0) {
                                    additional_run_charge_for_location =
                                        parseFloat(
                                            (
                                                decoration_price_last_color *
                                                total_gender_quantity
                                            ).toFixed(2)
                                        );
                                } else if (
                                    initalLocationIndex == 0 &&
                                    no_of_colors > 1
                                ) {
                                    additional_run_charge_for_location =
                                        parseFloat(
                                            (
                                                additional_color_cost *
                                                total_gender_quantity
                                            ).toFixed(2)
                                        );
                                }
                            }
                            location.decoration_fee =
                                additional_run_charge_for_location /
                                    total_gender_quantity || 0;
                            location.total_decoration_fee =
                                additional_run_charge_for_location;
                            totalCalculatedDecorationFee = parseFloat(
                                (
                                    totalCalculatedDecorationFee +
                                    additional_run_charge_for_location +
                                    location.total_decor_upcharge
                                ).toFixed(2)
                            );
                            location.is_full_color_selected = false;
                            initalLocationIndex++;
                        }
                    }
                });
            } else if (decoration_type == 2) {
                // Embroidery Logic
                imprint_locations.forEach((location) => {
                    if (location.is_selected) {
                        // Check if "Full color" is selected
                        if (
                            location.no_of_color === "full_color" ||
                            location.is_full_color === true
                        ) {
                            // Use full_color value from decoration service JSON for run charge
                            const fullColorValue = parseFloat(
                                this.activeDecorationService.full_color || 0
                            );
                            let calculatedFeePerItem = 0;

                            if (initalLocationIndex == 0) {
                                // First location - full color value only (no location fee for first location in old logic)
                                calculatedFeePerItem = fullColorValue;
                            } else {
                                // Additional locations - need to get location fee from template
                                let decoration_price = this.getDecorationPrice(
                                    0,
                                    initalLocationIndex
                                );
                                calculatedFeePerItem =
                                    fullColorValue +
                                    parseFloat(decoration_price || 0);
                            }

                            location.decoration_fee = calculatedFeePerItem;
                            location.total_decoration_fee =
                                parseFloat(location.decoration_fee) *
                                total_gender_quantity;
                            location.is_full_color_selected = true;
                            location.full_color_value = fullColorValue;
                            totalCalculatedDecorationFee +=
                                location.total_decoration_fee;
                            total_colors += 1; // Count as 1 for full color
                        } else {
                            let no_of_colors =
                                parseInt(location.no_of_color) || 0;
                            total_colors += no_of_colors;
                            location.total_decor_upcharge = 0;
                            location.colors.forEach((color) => {
                                /* ... upcharge logic ... */
                            });

                            if (initalLocationIndex == 0) {
                                location.decoration_fee = 0;
                                location.total_decoration_fee = 0;
                            } else {
                                let decoration_price = this.getDecorationPrice(
                                    0,
                                    initalLocationIndex
                                );
                                location.decoration_fee =
                                    parseFloat(decoration_price);
                                location.total_decoration_fee =
                                    parseFloat(location.decoration_fee) *
                                    total_gender_quantity;
                            }
                            location.is_full_color_selected = false;
                            totalCalculatedDecorationFee +=
                                location.total_decoration_fee || 0;
                            totalCalculatedDecorationFee +=
                                location.total_decor_upcharge || 0;
                        }
                        initalLocationIndex++;
                    }
                });
            }
            return { total_colors, totalCalculatedDecorationFee };
        },

        prepareDecorationPrices() {
            let gender = this.genderGroups[this.active_gender_index];
            let price_decoration_bulk = gender.item.price_decoration_bulk;
            // this.imprintcityColors = JSON.parse(
            //     JSON.stringify(this.default_imprint_colors)
            // );
            if (gender.item.decoration_type == 1) {
                let noOfColorsCount = price_decoration_bulk.no_of_colors;
                if (
                    gender.item.PrintTemplate &&
                    gender.item.PrintTemplate.discount_enable
                ) {
                    price_decoration_bulk.print_location1.forEach((row) => {
                        for (let i = 1; i < noOfColorsCount; i++) {
                            let discount_colour =
                                (parseFloat(row[`colour${i}`]) *
                                    parseFloat(row.discount)) /
                                100;
                            row[`colour${i}`] = parseFloat(
                                parseFloat(row[`colour${i}`]) -
                                    parseFloat(discount_colour)
                            ).toFixed(2);
                        }
                    });
                }
                this.decoration_price_template_values_for_imprint =
                    price_decoration_bulk.print_location1;
                this.decoration_price_template_values =
                    price_decoration_bulk.print_location1;
                this.decoration_price_template_location2 =
                    price_decoration_bulk.print_location2;

                // Added Number of colors for Imprint Locations
                noOfColorsCount = this.colorsCount;
                this.imprintcityColors = [];

                // Check if activeDecorationService has is_full_color set to true
                if (
                    this.activeDecorationService &&
                    this.activeDecorationService.is_full_color === true
                ) {
                    // Show only "1-color" and "Full color" options
                    this.imprintcityColors.push({
                        id: 1,
                        value: "1-color"
                    });
                    this.imprintcityColors.push({
                        id: "full_color",
                        value: "Full color"
                    });
                } else if (noOfColorsCount) {
                    if (noOfColorsCount !== undefined && noOfColorsCount > 0) {
                        for (
                            let noOfColor = 1;
                            noOfColor <= noOfColorsCount;
                            noOfColor++
                        ) {
                            this.imprintcityColors.push({
                                id: parseInt(noOfColor),
                                value: noOfColor + "-colors"
                            });
                        }
                    }
                }
            } else if (gender.item.decoration_type == 2) {
                this.decoration_price_template_values_for_imprint =
                    price_decoration_bulk;
                this.decoration_price_template_values = price_decoration_bulk;
            }
        },

        onCollapaseLocationColors(location) {
            /* eslint-disable */
            let index = this.genderGroups[
                this.active_gender_index
            ].imprint_locations.findIndex(
                (location_obj) => location_obj.location == location.location
            );
            if (this.index_prev != index)
                this.genderGroups[
                    this.active_gender_index
                ].imprint_locations.forEach((location_obj) => {
                    delete location_obj.collapse;
                });
            if (
                this.genderGroups[this.active_gender_index].imprint_locations[
                    index
                ].collapse == true
            )
                this.genderGroups[this.active_gender_index].imprint_locations[
                    index
                ].collapse = false;
            else
                this.genderGroups[this.active_gender_index].imprint_locations[
                    index
                ].collapse = true;
            this.index_prev = index;
            this.$forceUpdate();
            /* eslint-enable */
        },

        getTotalItemQuantity(gender_element) {
            let total_quantity = 0;
            if (
                gender_element &&
                gender_element.colors &&
                Array.isArray(gender_element.colors)
            ) {
                gender_element.colors.forEach((color) => {
                    if (
                        color.unique_sizes &&
                        Array.isArray(color.unique_sizes)
                    ) {
                        color.unique_sizes.forEach((size) => {
                            if (size.quantity && parseInt(size.quantity) > 0) {
                                total_quantity += parseInt(size.quantity);
                            }
                        });
                    }
                });
            }
            return total_quantity;
        },

        getRetailPrice(prices) {
            let item_price = 0;
            if (prices.base_price) {
                item_price += parseFloat(prices.base_price);
            }

            if (prices.markup_price) {
                item_price += parseFloat(prices.markup_price);
            }

            if (prices.single_location_price) {
                item_price += parseFloat(prices.single_location_price);
            }

            if (prices.color_category_price) {
                item_price += parseFloat(prices.color_category_price);
            }

            if (prices.decoration_discount_percentage) {
                let decoration_discount_value =
                    (this.icPriceFormat(item_price, true) *
                        parseFloat(prices.decoration_discount_percentage)) /
                    100;
                item_price -= parseFloat(decoration_discount_value);
            }

            return item_price;
        },

        getDecorationPrice(
            colorIndex = 0,
            locationIndex = undefined,
            additional = false
        ) {
            let qty_wise_color_price = 0;
            if (
                this.active_gender_index < 0 ||
                this.active_gender_index >= this.genderGroups.length
            ) {
                return 0;
            }
            let genderGroup = this.genderGroups[this.active_gender_index];
            if (
                !genderGroup ||
                !genderGroup.item ||
                !this.activeDecorationService
            ) {
                return 0;
            }

            let total_qty_gender_wise =
                this.getTotalItemQuantity(genderGroup) + this.cartQuantity;

            let productData = genderGroup.item; // Keep for fallback? Or rely solely on activeService?
            let price_decoration_bulk_data =
                this.activeDecorationService.price_decoration_bulk; // Use data from active service

            // Decoration type comes from active service now
            let decoration_type = this.activeDecorationService.decoration_type;

            if (!price_decoration_bulk_data) {
                return 0;
            }

            // PCNA (decoration_type == 0) uses master_service pricing, not price_decoration_bulk
            if (decoration_type == 0) {
                return 0;
            }

            if (decoration_type == 1) {
                // Print
                let decoration_data;
                // Check structure within activeService's bulk price data
                if (
                    !price_decoration_bulk_data ||
                    !price_decoration_bulk_data.print_location1 ||
                    !price_decoration_bulk_data.print_location2
                ) {
                    console.error(
                        "Print price data structure missing in activeService.price_decoration_bulk:",
                        price_decoration_bulk_data
                    );
                    return 0;
                }

                decoration_data = !additional
                    ? price_decoration_bulk_data.print_location1
                    : price_decoration_bulk_data.print_location2;

                if (Array.isArray(decoration_data)) {
                    let foundPrice = false;
                    for (let i = decoration_data.length - 1; i >= 0; i--) {
                        const element = decoration_data[i];
                        if (
                            element &&
                            element.quantity !== undefined &&
                            element[`colour${colorIndex + 1}`] !== undefined
                        ) {
                            if (
                                parseInt(element.quantity) <=
                                parseInt(total_qty_gender_wise)
                            ) {
                                qty_wise_color_price =
                                    element[`colour${colorIndex + 1}`];
                                foundPrice = true;
                                break;
                            }
                        } else {
                            console.warn(
                                "Skipping malformed print price tier:",
                                element
                            );
                        }
                    }
                    if (
                        !foundPrice &&
                        decoration_data.length > 0 &&
                        decoration_data[0] &&
                        decoration_data[0][`colour${colorIndex + 1}`] !==
                            undefined
                    ) {
                        qty_wise_color_price =
                            decoration_data[0][`colour${colorIndex + 1}`];
                    } else if (!foundPrice) {
                        qty_wise_color_price = 0;
                    }
                } else {
                    return 0;
                }
            } else if (decoration_type == 2) {
                // Embroidery
                // Assuming price_decoration_bulk is the array of tiers directly for embroidery
                let decoration_data = price_decoration_bulk_data;
                if (Array.isArray(decoration_data)) {
                    let foundPrice = false;
                    for (let i = decoration_data.length - 1; i >= 0; i--) {
                        const element = decoration_data[i];
                        if (element && element.quantity1 !== undefined) {
                            // Check embroidery quantity key
                            if (
                                parseInt(element.quantity1) <=
                                parseInt(total_qty_gender_wise)
                            ) {
                                if (
                                    locationIndex !== undefined &&
                                    locationIndex > 0
                                ) {
                                    // Get price for additional location
                                    qty_wise_color_price =
                                        element[
                                            `location${locationIndex + 1}`
                                        ] !== undefined
                                            ? element[
                                                  `location${locationIndex + 1}`
                                              ]
                                            : element["cost"] !== undefined
                                            ? element["cost"]
                                            : 0; // Fallback to base cost
                                } else {
                                    // Get base cost for first location
                                    qty_wise_color_price =
                                        element["cost"] !== undefined
                                            ? element["cost"]
                                            : 0;
                                }
                                foundPrice = true;
                                break;
                            }
                        } else {
                            console.warn(
                                "Skipping malformed embroidery price tier:",
                                element
                            );
                        }
                    }
                    // Fallback to first tier
                    if (
                        !foundPrice &&
                        decoration_data.length > 0 &&
                        decoration_data[0]
                    ) {
                        const firstElement = decoration_data[0];
                        if (locationIndex !== undefined && locationIndex > 0) {
                            qty_wise_color_price =
                                firstElement[`location${locationIndex + 1}`] !==
                                undefined
                                    ? firstElement[
                                          `location${locationIndex + 1}`
                                      ]
                                    : firstElement["cost"] !== undefined
                                    ? firstElement["cost"]
                                    : 0;
                        } else {
                            qty_wise_color_price =
                                firstElement["cost"] !== undefined
                                    ? firstElement["cost"]
                                    : 0;
                        }
                    } else if (!foundPrice) {
                        qty_wise_color_price = 0;
                    }
                } else {
                    return 0;
                }
            } else {
                return 0;
            }

            return parseFloat(qty_wise_color_price || 0);
        },

        getDecorationDiscount(additional = false) {
            let discount = 0;

            let total_qty_gender_wise = this.getTotalItemQuantity(
                this.genderGroups[this.active_gender_index]
            );
            let productData = this.genderGroups[this.active_gender_index].item;

            // PCNA (decoration_type == 0) doesn't use this discount structure
            if (productData.decoration_type == 0) {
                return 0;
            }

            if (productData.decoration_type == 1) {
                let decoration_data;

                if (!productData.price_decoration_bulk) {
                    return 0;
                }

                if (!additional) {
                    decoration_data =
                        productData.price_decoration_bulk.print_location1;
                } else {
                    decoration_data =
                        productData.price_decoration_bulk.print_location2;
                }

                if (!decoration_data || !Array.isArray(decoration_data)) {
                    return 0;
                }

                let total_group_quantity = parseInt(total_qty_gender_wise);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity <= total_group_quantity ||
                        index == 0
                    ) {
                        discount = element["discount"];
                    }
                }
            } else if (productData.decoration_type == 2) {
                if (!productData.price_decoration_bulk) {
                    return 0;
                }
                let decoration_data = productData.price_decoration_bulk;
                if (!decoration_data || !Array.isArray(decoration_data)) {
                    return 0;
                }
                let total_group_quantity = parseInt(total_qty_gender_wise);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity1 <= total_group_quantity ||
                        index == 0
                    ) {
                        discount = element["discount"];
                    }
                }
            }

            return parseFloat(discount || 0);
        },

        // Inside ItemDetails.vue methods
        calculatePricing(index, size, event = null) {
            const _this = this;

            //Max cart count validation
            if (event && event.target.value > _this.max_cart_count) {
                _this.$toast.error(
                    `Quantity cannot exceed ${_this.max_cart_count}`,
                    { position: "top-right", queue: true }
                );
                if (size) {
                    const previousValue = size.quantity
                        ? parseInt(String(size.quantity).slice(0, -1))
                        : 0; // Attempt to get previous value
                    size.quantity =
                        previousValue > _this.max_cart_count
                            ? _this.max_cart_count
                            : previousValue; // Revert or cap at max
                }
                _this.$forceUpdate(); // Ensure UI reflects the change
                return; // Stop calculation
            }

            //Check active service
            if (!_this.activeDecorationService) {
                console.error(
                    "calculatePricing: activeDecorationService is missing."
                );
                _this.$toast.error(`Decoration service not selected.`, {
                    position: "top-right",
                    queue: true
                });
                return;
            }

            //Get decoration_type from active service
            const decorationType =
                _this.activeDecorationService.decoration_type;

            //Call relevant pricing function based on decoration_type
            switch (decorationType) {
                case 0: // PCNA Type
                    if (typeof _this.calculatePCNAPricing === "function") {
                        _this.calculatePCNAPricing(index); // Call the dedicated PCNA function
                    } else {
                        console.error(
                            "calculatePCNAPricing function is not defined"
                        );
                    }
                    break;
                case 1: // Print
                    if (typeof _this.calculatePrintPricing === "function") {
                        _this.calculatePrintPricing(index);
                    } else {
                        console.error(
                            "calculatePrintPricing function is not defined"
                        );
                    }
                    break;
                case 2: // Embroidery
                    if (
                        typeof _this.calculateEmbroideryPricing === "function"
                    ) {
                        _this.calculateEmbroideryPricing(index);
                    } else {
                        console.error(
                            "calculateEmbroideryPricing function is not defined"
                        );
                    }
                    break;
                // Add other cases like case 3: if needed
                default:
                    console.warn(
                        `calculatePricing: Unknown decoration type: ${decorationType}`
                    );
                    _this.$toast.error(
                        `Unsupported decoration type: ${decorationType}`,
                        { position: "top-right", queue: true }
                    );
            }

            // Emit event after calculation (if needed)
            this.$emit("updateNameAndNumbers");
        },

        calculatePCNAPricing(index) {
            //Validations
            if (
                index === undefined ||
                index < 0 ||
                !this.genderGroups ||
                index >= this.genderGroups.length ||
                !this.activeDecorationService ||
                !this.activeDecorationService.price_decoration_bulk ||
                !this.activeDecorationService.master_service
            ) {
                console.error(
                    "PCNA Pricing ERROR: Invalid index, data, or missing activeDecorationService/price_decoration_bulk/master_service:",
                    index,
                    this.activeDecorationService
                );
                this.$toast.error(
                    "Error: Missing required data for calculation.",
                    { position: "top-right" }
                );
                return;
            }

            let gender_element = this.genderGroups[index];
            const priceData =
                this.activeDecorationService.price_decoration_bulk;
            const masterServicePricing =
                this.activeDecorationService.master_service;

            //Reset Gender Totals
            gender_element.total_qty = 0;
            gender_element.subtotal = 0; // Base cost of items
            gender_element.total_cost = 0; // Final total
            gender_element.total_discount_value = 0; // Promotional discount
            gender_element.total_design_fee = 0;
            gender_element.total_color_fee = 0; // Run charges
            gender_element.total_setup_fee = 0; // Setup fee
            gender_element.total_decoration_colors = 0; // Reset total colors count
            gender_element.total_front_name_fees = 0;
            gender_element.total_back_name_fees = 0;
            gender_element.total_front_number_fees = 0;
            gender_element.total_back_number_fees = 0;
            gender_element.total_front_number_decor_up_fees = 0;
            gender_element.total_back_name_decor_up_fees = 0;
            gender_element.total_back_number_decor_up_fees = 0;
            gender_element.total_non_standard_fees = 0;

            let total_group_quantity =
                this.getTotalItemQuantity(gender_element);

            //Find Pricing Tier for Base Item Cost
            let found_tier = null;
            if (Array.isArray(priceData) && priceData.length > 0) {
                // Iterate backwards to find the highest applicable tier
                for (let i = priceData.length - 1; i >= 0; i--) {
                    const tier = priceData[i];
                    if (
                        tier &&
                        tier.quantity !== undefined &&
                        parseInt(tier.quantity) <= total_group_quantity
                    ) {
                        found_tier = tier;
                        break;
                    }
                }
                // If quantity is below the lowest tier, use the first tier
                if (!found_tier) {
                    found_tier = priceData[0];
                }
            }

            if (
                !found_tier ||
                found_tier.retail_cost === undefined ||
                found_tier.retail_cost === null
            ) {
                console.error(
                    " -> PCNA Pricing ERROR: Could not determine valid pricing tier or retail_cost missing.",
                    found_tier
                );
                this.$toast.error("Error determining base item price.", {
                    position: "top-right"
                });
                return;
            }
            let tier_retail_cost = parseFloat(found_tier.retail_cost);

            //Calculate Subtotal (Base Item Costs) and aggregate name/number fees
            gender_element.colors.forEach((color) => {
                color.total_qty_gender_wise = 0;
                color.subtotal = 0;
                color.total_cost_gender_wise = 0; // Reset color specific cost

                // Update non_standard_fee for custom colors in PCNA case
                if (
                    color.imprint_locations &&
                    Array.isArray(color.imprint_locations)
                ) {
                    color.imprint_locations.forEach((location) => {
                        if (location.colors && Array.isArray(location.colors)) {
                            location.colors.forEach((colorObj) => {
                                if (
                                    colorObj.color &&
                                    colorObj.color.color_id == 0
                                ) {
                                    // It's a custom color, set non_standard_fee if not already set
                                    if (
                                        !colorObj.color.non_standard_fee ||
                                        colorObj.color.non_standard_fee === 0
                                    ) {
                                        let feePerColor =
                                            this.getPCNAFeePerColor();
                                        if (feePerColor > 0) {
                                            colorObj.color.non_standard_fee =
                                                feePerColor;
                                        }
                                    }
                                }
                            });
                        }
                    });
                }

                color.unique_sizes.forEach((size) => {
                    size.cost = tier_retail_cost; // Apply tier cost
                    // Reset others just in case
                    size.markup_price = 0;
                    size.ink_price = 0;
                    size.single_location_price = 0;
                    size.decoration_discount_percentage = 0;

                    const quantity = parseInt(size.quantity || 0);
                    size.total_cost = quantity > 0 ? size.cost * quantity : 0; // Base cost for this size * qty

                    if (quantity > 0) {
                        color.total_qty_gender_wise += quantity;
                        color.subtotal += size.total_cost; // Add base cost to color's subtotal
                    }
                });
                color.total_cost_gender_wise = color.subtotal; // Color total starts as its subtotal

                // Aggregate design fee from colors
                gender_element.total_design_fee += parseFloat(
                    color.total_design_fee || 0
                );
                // Note: Name and number fees are now calculated from VendorOtherServices below

                // Aggregate name and number decor up fees from colors (for PCNA)
                gender_element.total_front_number_decor_up_fees += parseFloat(
                    color.front_number_decor_up_fees || 0
                );
                gender_element.total_back_name_decor_up_fees += parseFloat(
                    color.back_name_decor_up_fees || 0
                );
                gender_element.total_back_number_decor_up_fees += parseFloat(
                    color.back_number_decor_up_fees || 0
                );

                // Aggregate up
                gender_element.total_qty += color.total_qty_gender_wise;
                gender_element.subtotal += color.subtotal; // Add color's base cost subtotal to gender's base cost subtotal
            });

            const runChargeResult =
                this.calcImprintLocationByGender(masterServicePricing);
            let locationRunCharge = parseFloat(
                runChargeResult.totalCalculatedDecorationFee || 0
            ); // Store run charges
            gender_element.total_decoration_colors =
                runChargeResult.total_colors; // Store total colors used

            // Initialize detailsForRunCharge array for tooltip breakdown
            let detailsForRunCharge = [];

            // Add location run charge to total_color_fee and details
            if (locationRunCharge > 0) {
                gender_element.total_color_fee += locationRunCharge;
                detailsForRunCharge.push({
                    name: "Location(s) Run Charge",
                    value: parseFloat(locationRunCharge.toFixed(2))
                });
            }

            const otherServicesTotal = this.otherServices.reduce(
                (total, service) => {
                    const cost = parseFloat(service.retail_cost) || 0;
                    if (service.fee_structure === "Per Item") {
                        // Multiply by quantity if it's 'Per Item'
                        return total + cost * total_group_quantity;
                    } else {
                        // Otherwise, just add the flat fee
                        return total + cost;
                    }
                },
                0
            );

            // Calculate Setup Fee
            this.setup_fee = 0;
            this.setup_fee_applied_gender_index = -1;
            // Only calculate if quantity > 0 AND colors are selected
            if (
                total_group_quantity > 0 &&
                gender_element.total_decoration_colors > 0
            ) {
                const feeStructure = masterServicePricing.fee_structure; // e.g., "1" or "2"
                const setupFeeColor1 = parseFloat(
                    masterServicePricing.setup_fee_color1 || 0
                );
                const setupFeeMulticolor = parseFloat(
                    masterServicePricing.setup_fee_multicolor || 0
                );

                if (feeStructure == "1") {
                    // Per Color
                    this.setup_fee =
                        setupFeeColor1 * gender_element.total_decoration_colors;
                } else if (feeStructure == "2") {
                    // Tiered
                    if (gender_element.total_decoration_colors === 1) {
                        this.setup_fee = setupFeeColor1;
                    } else if (gender_element.total_decoration_colors > 1) {
                        this.setup_fee = setupFeeMulticolor;
                    }
                } else {
                    console.warn(
                        " -> PCNA Pricing WARNING: Unknown setup fee structure:",
                        feeStructure
                    );
                }
                gender_element.total_setup_fee = this.setup_fee;
                if (this.setup_fee > 0) {
                    this.setup_fee_applied_gender_index = index; // Track which gender got the fee
                }
            } else {
                gender_element.total_setup_fee = 0; // No setup fee if no quantity or no colors selected
            }

            // Vendor Color Upcharges (same logic as print and embroidery)
            let vendorColorUpcharge = 0;
            if (this.allDecorationColors && total_group_quantity > 0) {
                for (const [flip, colorHexCodes] of Object.entries(
                    this.allDecorationColors
                )) {
                    if (colorHexCodes) {
                        colorHexCodes.forEach((hexCode) => {
                            if (!hexCode) return;
                            const vendorColor = this.vendorColors.find(
                                (color) =>
                                    color.color_value &&
                                    color.color_value.toLowerCase() ===
                                        (typeof hexCode === "string"
                                            ? hexCode.toLowerCase()
                                            : hexCode.hex
                                            ? hexCode.hex.toLowerCase()
                                            : "")
                            );
                            if (vendorColor && vendorColor.decor_upcharge) {
                                vendorColorUpcharge +=
                                    parseFloat(
                                        vendorColor.decor_upcharge || 0
                                    ) * parseInt(total_group_quantity);
                            }
                        });
                    }
                }
            }
            if (vendorColorUpcharge > 0) {
                vendorColorUpcharge = parseFloat(
                    vendorColorUpcharge.toFixed(2)
                );
                gender_element.total_color_fee += vendorColorUpcharge;
                detailsForRunCharge.push({
                    name: "Specialty Ink Fee",
                    value: vendorColorUpcharge
                });
            }

            // Mix Color Fee calculation - Get from VendorOtherServices
            const activeService = this.activeDecorationService;
            const serviceName = activeService
                ? (activeService.name || "").toLowerCase()
                : "";
            const decorationType =
                activeService && activeService.master_service
                    ? activeService.master_service.decoration_type
                    : null;

            // Get custom color fee from VendorOtherServices
            let colorMixFeePerColor = this.getColorMixFeeFromVendorServices(
                decorationType,
                serviceName
            );

            // Get unique non-standard color count
            let uniqueNonStandardColorCount =
                this.getUniqueNonStandardColorCount();

            // Calculate mix fee: unique non-standard color count × fee per color (NO quantity multiplication)
            let calculatedMixFee = 0;
            if (
                colorMixFeePerColor !== null &&
                uniqueNonStandardColorCount > 0
            ) {
                calculatedMixFee =
                    uniqueNonStandardColorCount * colorMixFeePerColor;
            }

            gender_element.total_non_standard_fees = calculatedMixFee;
            if (gender_element.total_non_standard_fees > 0) {
                // Ensure mix fee is properly added to total_color_fee
                const mixFeeToAdd = parseFloat(
                    gender_element.total_non_standard_fees.toFixed(2)
                );
                gender_element.total_color_fee += mixFeeToAdd;

                // Get mix color count and unit price for display
                let mixColorCount = uniqueNonStandardColorCount;
                let feePerColor = colorMixFeePerColor || 0;

                // Determine mix fee label based on decoration type or service name
                const isEmbroideryService = serviceName.includes("embroidery");
                const mixFeeLabel =
                    decorationType == 2 || isEmbroideryService
                        ? "Custom Color Thread Fee"
                        : "Custom Color Ink Fee";

                detailsForRunCharge.push({
                    name: mixFeeLabel,
                    value: mixFeeToAdd,
                    mixColorCount: mixColorCount,
                    unitPrice: feePerColor,
                    quantity: total_group_quantity
                });
            }

            // Name and Number Fees - Get from VendorOtherServices
            // Only apply if front/back has decorations, calculate based on actual name/number count per location
            const nameFeePerItem = this.getNameFeeFromVendorServices();
            const numberFeePerItem = this.getNumberFeeFromVendorServices();

            // Initialize fees to 0
            gender_element.total_front_name_fees = 0;
            gender_element.total_back_name_fees = 0;
            gender_element.total_front_number_fees = 0;
            gender_element.total_back_number_fees = 0;

            // Count actual names and numbers per location (front/back) based on selected_name_number
            const {
                frontNameCount,
                backNameCount,
                frontNumberCount,
                backNumberCount
            } = this.countNamesAndNumbersByLocation(this.active_gender_index);

            // Check if front or back has decorations
            const { hasFront, hasBack } = this.hasFrontOrBackDecoration(
                this.active_gender_index
            );

            // Only calculate fees if there are actual names/numbers added (count > 0), not just when decoration is added
            if (
                frontNameCount > 0 ||
                backNameCount > 0 ||
                frontNumberCount > 0 ||
                backNumberCount > 0
            ) {
                // Calculate name fees per location (back only - names are only on back)
                if (nameFeePerItem !== null && backNameCount > 0 && hasBack) {
                    gender_element.total_back_name_fees =
                        backNameCount * nameFeePerItem;
                    if (gender_element.total_back_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_back_name_fees;
                        detailsForRunCharge.push({
                            name: "Back Name Fee",
                            value: parseFloat(
                                gender_element.total_back_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: backNameCount
                        });
                    }
                }

                // Calculate number fees per location (front and back)
                if (numberFeePerItem !== null) {
                    // Front number fee - only if numbers are added for front
                    if (frontNumberCount > 0 && hasFront) {
                        gender_element.total_front_number_fees =
                            frontNumberCount * numberFeePerItem;
                        if (gender_element.total_front_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_front_number_fees;
                            detailsForRunCharge.push({
                                name: "Front Number Fee",
                                value: parseFloat(
                                    gender_element.total_front_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: frontNumberCount
                            });
                        }
                    }

                    // Back number fee - only if numbers are added for back
                    if (backNumberCount > 0 && hasBack) {
                        gender_element.total_back_number_fees =
                            backNumberCount * numberFeePerItem;
                        if (gender_element.total_back_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_back_number_fees;
                            detailsForRunCharge.push({
                                name: "Back Number Fee",
                                value: parseFloat(
                                    gender_element.total_back_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: backNumberCount
                            });
                        }
                    }
                }
            }

            // Front Number Decor Up Fee
            if (gender_element.total_front_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_front_number_decor_up_fees;

                // Get quantity from Front Number Fee (number of front numbers)
                const frontNumberFee = detailsForRunCharge.find(
                    (d) =>
                        d.name &&
                        d.name.toLowerCase().includes("front number fee") &&
                        !d.name.toLowerCase().includes("decor up")
                );
                const quantity = frontNumberFee
                    ? parseFloat(frontNumberFee.quantity || 0)
                    : frontNumberCount;

                // Calculate unit price: total decor up fee divided by quantity
                const unitPrice =
                    quantity > 0
                        ? parseFloat(
                              (
                                  gender_element.total_front_number_decor_up_fees /
                                  quantity
                              ).toFixed(2)
                          )
                        : parseFloat(
                              gender_element.total_front_number_decor_up_fees.toFixed(
                                  2
                              )
                          );

                detailsForRunCharge.push({
                    name: "Front Number Decor Up Fee",
                    value: parseFloat(
                        gender_element.total_front_number_decor_up_fees.toFixed(
                            2
                        )
                    ),
                    unitPrice: unitPrice,
                    quantity: quantity
                });
            }

            // Back Name Decor Up Fee
            if (gender_element.total_back_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_back_name_decor_up_fees;

                // Get quantity from Back Name Fee (number of back names)
                const backNameFee = detailsForRunCharge.find(
                    (d) =>
                        d.name &&
                        d.name.toLowerCase().includes("back name fee") &&
                        !d.name.toLowerCase().includes("decor up")
                );
                const quantity = backNameFee
                    ? parseFloat(backNameFee.quantity || 0)
                    : backNameCount;

                // Calculate unit price: total decor up fee divided by quantity
                const unitPrice =
                    quantity > 0
                        ? parseFloat(
                              (
                                  gender_element.total_back_name_decor_up_fees /
                                  quantity
                              ).toFixed(2)
                          )
                        : parseFloat(
                              gender_element.total_back_name_decor_up_fees.toFixed(
                                  2
                              )
                          );

                detailsForRunCharge.push({
                    name: "Back Name Decor Up Fee",
                    value: parseFloat(
                        gender_element.total_back_name_decor_up_fees.toFixed(2)
                    ),
                    unitPrice: unitPrice,
                    quantity: quantity
                });
            }

            // Back Number Decor Up Fee
            if (gender_element.total_back_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_back_number_decor_up_fees;

                // Get quantity from Back Number Fee (number of back numbers)
                const backNumberFee = detailsForRunCharge.find(
                    (d) =>
                        d.name &&
                        d.name.toLowerCase().includes("back number fee") &&
                        !d.name.toLowerCase().includes("decor up")
                );
                const quantity = backNumberFee
                    ? parseFloat(backNumberFee.quantity || 0)
                    : backNumberCount;

                // Calculate unit price: total decor up fee divided by quantity
                const unitPrice =
                    quantity > 0
                        ? parseFloat(
                              (
                                  gender_element.total_back_number_decor_up_fees /
                                  quantity
                              ).toFixed(2)
                          )
                        : parseFloat(
                              gender_element.total_back_number_decor_up_fees.toFixed(
                                  2
                              )
                          );

                detailsForRunCharge.push({
                    name: "Back Number Decor Up Fee",
                    value: parseFloat(
                        gender_element.total_back_number_decor_up_fees.toFixed(
                            2
                        )
                    ),
                    unitPrice: unitPrice,
                    quantity: quantity
                });
            }

            // Final Total Run Charge (round to 2 decimal places)
            gender_element.total_color_fee = parseFloat(
                gender_element.total_color_fee.toFixed(2)
            );


            // Total = BaseItemCosts + RunCharges + SetupFee
            const preDiscountTotal =
                gender_element.subtotal +
                gender_element.total_color_fee +
                gender_element.total_setup_fee +
                otherServicesTotal;

            //Calculate Promotional Discount
            let mainDiscountAmount = 0;
            const activeDiscount = this.activeProductDiscount; // Use the computed property
            if (activeDiscount && preDiscountTotal > 0) {
                let discount_type = activeDiscount.discount_type;
                let discount_value = parseFloat(activeDiscount.discount_value);
                if (discount_type == "Percent") {
                    mainDiscountAmount =
                        (preDiscountTotal * discount_value) / 100;
                } else {
                    // Fixed amount
                    mainDiscountAmount = Math.min(
                        preDiscountTotal,
                        discount_value
                    );
                }
            }
            gender_element.total_discount_value = mainDiscountAmount; // Store the discount amount

            // Calculate Final Total Cost
            gender_element.total_cost =
                preDiscountTotal - gender_element.total_discount_value; // Apply discount

            //Update picked_color for display in size table
            if (
                this.activeColorIndex >= 0 &&
                this.activeColorIndex < gender_element.colors.length
            ) {
                this.picked_color =
                    gender_element.colors[this.activeColorIndex];
            } else {
                this.picked_color = null; // Should not happen if logic is correct
            }

            // Update Breakdown Object for PriceBreakdown Component
            // Create new array reference to ensure Vue reactivity detects the change
            this.currentBreakdown = {
                baseCost: gender_element.subtotal,
                runCharge: gender_element.total_color_fee,
                setupFee: gender_element.total_setup_fee,
                totalCost: gender_element.total_cost,
                totalDiscount: gender_element.total_discount_value,
                designFee: gender_element.total_design_fee, // Usually 0 for PCNA
                runChargeDetails: [...detailsForRunCharge] // Create new array reference for reactivity
            };

            // Force update to ensure PCNAPriceBreakdown component reflects name/number fee changes
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },

        calculatePrintPricing(index) {
            const activeService = this.activeDecorationService;
            if (!activeService) {
                this.$toast.error(
                    "Error: Active decoration service is missing.",
                    {
                        position: "top-right"
                    }
                );
                return;
            }
            if (
                !this.genderGroups ||
                index === undefined ||
                !this.genderGroups[index]
            ) {
                this.$toast.error("Error: Product data not loaded correctly.", {
                    position: "top-right"
                });
                return;
            }
            let gender_element = this.genderGroups[index];
            if (!this.product) {
                this.$toast.error(
                    "Error: Base product information is missing.",
                    {
                        position: "top-right"
                    }
                );
                return;
            }

            gender_element.total_qty = 0;
            gender_element.subtotal = 0;
            gender_element.total_cost = 0;
            gender_element.total_discount_value = 0;
            gender_element.total_design_fee = 0;
            gender_element.total_color_fee = 0;
            gender_element.total_setup_fee = 0;
            gender_element.total_decoration_colors = 0;
            gender_element.per_color_setup_cost = 0;
            gender_element.total_front_name_fees = 0;
            gender_element.total_back_name_fees = 0;
            gender_element.total_front_number_fees = 0;
            gender_element.total_back_number_fees = 0;
            gender_element.total_front_number_decor_up_fees = 0;
            gender_element.total_back_name_decor_up_fees = 0;
            gender_element.total_back_number_decor_up_fees = 0;
            gender_element.total_non_standard_fees = 0;
            this.setup_fee = 0;
            this.setup_fee_applied_gender_index = -1;

            let detailsForRunCharge = [];

            let total_group_quantity =
                this.getTotalItemQuantity(gender_element);
            let base_decoration_price = parseFloat(
                this.getDecorationPrice(0) || 0
            );
            let decoration_discount_percentage = parseFloat(
                this.getDecorationDiscount() || 0
            );
            let decoration_discount_amount = parseFloat(
                (
                    (base_decoration_price * decoration_discount_percentage) /
                    100
                ).toFixed(2)
            );
            let discounted_base_decoration_price = parseFloat(
                (base_decoration_price - decoration_discount_amount).toFixed(2)
            );

            if (gender_element.colors && gender_element.colors.length > 0) {
                gender_element.colors.forEach((selected_color_obj) => {
                    selected_color_obj.total_qty_gender_wise = 0;
                    selected_color_obj.subtotal = 0;
                    selected_color_obj.total_cost_gender_wise = 0;

                    selected_color_obj.unique_sizes.forEach((size) => {
                        let base_price = parseFloat(
                            size.price_base || this.product.price_base || 0
                        );
                        let markup_percentage = parseFloat(
                            activeService.markup_percentage ||
                                this.product.price_markup_percentage ||
                                0
                        );
                        let mark_up_cost = parseFloat(
                            ((base_price * markup_percentage) / 100).toFixed(2)
                        );
                        let color_category_price = parseFloat(
                            this.getDarkLightFees(selected_color_obj) || 0
                        );
                        size.markup_price = mark_up_cost;
                        size.single_location_price = base_decoration_price;
                        size.decoration_discount_percentage =
                            decoration_discount_percentage;
                        size.ink_price = color_category_price;
                        size.cost = parseFloat(
                            (
                                base_price +
                                mark_up_cost +
                                color_category_price +
                                discounted_base_decoration_price
                            ).toFixed(2)
                        );
                        const quantity = parseInt(size.quantity || 0);
                        size.total_cost =
                            quantity > 0
                                ? parseFloat((size.cost * quantity).toFixed(2))
                                : 0;
                        if (quantity > 0) {
                            selected_color_obj.subtotal = parseFloat(
                                (
                                    selected_color_obj.subtotal +
                                    size.total_cost
                                ).toFixed(2)
                            );
                            selected_color_obj.total_qty_gender_wise +=
                                quantity;
                        }
                    });

                    gender_element.total_design_fee += parseFloat(
                        selected_color_obj.total_design_fee || 0
                    );
                    // Note: Name and number fees are now calculated from VendorOtherServices below
                    gender_element.total_front_number_decor_up_fees +=
                        parseFloat(
                            selected_color_obj.front_number_decor_up_fees || 0
                        );
                    gender_element.total_back_name_decor_up_fees += parseFloat(
                        selected_color_obj.back_name_decor_up_fees || 0
                    );
                    gender_element.total_back_number_decor_up_fees +=
                        parseFloat(
                            selected_color_obj.back_number_decor_up_fees || 0
                        );

                    gender_element.subtotal = parseFloat(
                        (
                            gender_element.subtotal +
                            selected_color_obj.subtotal
                        ).toFixed(2)
                    );
                    gender_element.total_qty +=
                        selected_color_obj.total_qty_gender_wise;
                });
            }

            // Location Run Charges
            const runChargeResult = this.calcImprintLocationByGender();
            let locationRunCharge = parseFloat(
                parseFloat(
                    runChargeResult.totalCalculatedDecorationFee || 0
                ).toFixed(2)
            );
            gender_element.total_color_fee += locationRunCharge;
            gender_element.total_decoration_colors =
                runChargeResult.total_colors;
            if (locationRunCharge > 0) {
                detailsForRunCharge.push({
                    name: "Location(s) Run Charge",
                    value: locationRunCharge
                });
            }

            // Vendor Color Upcharges
            let vendorColorUpcharge = 0;
            if (this.allDecorationColors && total_group_quantity > 0) {
                for (const [flip, colorHexCodes] of Object.entries(
                    this.allDecorationColors
                )) {
                    if (colorHexCodes) {
                        colorHexCodes.forEach((hexCode) => {
                            if (!hexCode) return;
                            const vendorColor = this.vendorColors.find(
                                (color) =>
                                    color.color_value.toLowerCase() ===
                                    (typeof hexCode === "string"
                                        ? hexCode.toLowerCase()
                                        : hexCode.hex.toLowerCase())
                            );
                            if (vendorColor && vendorColor.decor_upcharge) {
                                vendorColorUpcharge +=
                                    parseFloat(
                                        vendorColor.decor_upcharge || 0
                                    ) * parseInt(total_group_quantity);
                            }
                        });
                    }
                }
            }
            if (vendorColorUpcharge > 0) {
                vendorColorUpcharge = parseFloat(
                    vendorColorUpcharge.toFixed(2)
                );
                gender_element.total_color_fee += vendorColorUpcharge;
                detailsForRunCharge.push({
                    name: "Specialty Ink Fee",
                    value: vendorColorUpcharge
                });
            }

            // Custom Color Fee - Get from VendorOtherServices
            const serviceName = activeService
                ? (activeService.name || "").toLowerCase()
                : "";
            const decorationType =
                activeService && activeService.master_service
                    ? activeService.master_service.decoration_type
                    : 1; // Default to 1 (Screen Print) for calculatePrintPricing

            // Get custom color fee from VendorOtherServices
            let colorMixFeePerColor = this.getColorMixFeeFromVendorServices(
                decorationType,
                serviceName
            );

            // Get unique non-standard color count
            let uniqueNonStandardColorCount =
                this.getUniqueNonStandardColorCount();

            // Calculate mix fee: unique non-standard color count × fee per color (NO quantity multiplication)
            let calculatedMixFee = 0;
            if (
                colorMixFeePerColor !== null &&
                uniqueNonStandardColorCount > 0
            ) {
                calculatedMixFee =
                    uniqueNonStandardColorCount * colorMixFeePerColor;
            }

            gender_element.total_non_standard_fees = calculatedMixFee;
            if (gender_element.total_non_standard_fees > 0) {
                const mixFeeToAdd = parseFloat(
                    gender_element.total_non_standard_fees.toFixed(2)
                );
                gender_element.total_color_fee += mixFeeToAdd;

                detailsForRunCharge.push({
                    name: "Custom Color Ink Fee",
                    value: mixFeeToAdd,
                    mixColorCount: uniqueNonStandardColorCount,
                    unitPrice: colorMixFeePerColor || 0,
                    quantity: total_group_quantity
                });
            }

            // Name and Number Fees - Get from VendorOtherServices
            // Only apply if front/back has decorations, calculate based on actual name/number count per location
            const nameFeePerItem = this.getNameFeeFromVendorServices();
            const numberFeePerItem = this.getNumberFeeFromVendorServices();

            // Initialize fees to 0
            gender_element.total_front_name_fees = 0;
            gender_element.total_back_name_fees = 0;
            gender_element.total_front_number_fees = 0;
            gender_element.total_back_number_fees = 0;

            // Count actual names and numbers per location (front/back) based on selected_name_number
            const {
                frontNameCount,
                backNameCount,
                frontNumberCount,
                backNumberCount
            } = this.countNamesAndNumbersByLocation(this.active_gender_index);

            // Check if front or back has decorations
            const { hasFront, hasBack } = this.hasFrontOrBackDecoration(
                this.active_gender_index
            );

            // Only calculate fees if there are actual names/numbers added (count > 0), not just when decoration is added
            if (
                frontNameCount > 0 ||
                backNameCount > 0 ||
                frontNumberCount > 0 ||
                backNumberCount > 0
            ) {
                // Calculate name fees per location (back only - names are only on back)
                if (nameFeePerItem !== null && backNameCount > 0 && hasBack) {
                    gender_element.total_back_name_fees =
                        backNameCount * nameFeePerItem;
                    if (gender_element.total_back_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_back_name_fees;
                        detailsForRunCharge.push({
                            name: "Back Name Fee",
                            value: parseFloat(
                                gender_element.total_back_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: backNameCount
                        });
                    }
                }

                // Calculate number fees per location (front and back)
                if (numberFeePerItem !== null) {
                    // Front number fee - only if numbers are added for front
                    if (frontNumberCount > 0 && hasFront) {
                        gender_element.total_front_number_fees =
                            frontNumberCount * numberFeePerItem;
                        if (gender_element.total_front_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_front_number_fees;
                            detailsForRunCharge.push({
                                name: "Front Number Fee",
                                value: parseFloat(
                                    gender_element.total_front_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: frontNumberCount
                            });
                        }
                    }

                    // Back number fee - only if numbers are added for back
                    if (backNumberCount > 0 && hasBack) {
                        gender_element.total_back_number_fees =
                            backNumberCount * numberFeePerItem;
                        if (gender_element.total_back_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_back_number_fees;
                            detailsForRunCharge.push({
                                name: "Back Number Fee",
                                value: parseFloat(
                                    gender_element.total_back_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: backNumberCount
                            });
                        }
                    }
                }
            }
            if (gender_element.total_front_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_front_number_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Front Number Decor Up Fee",
                    value: gender_element.total_front_number_decor_up_fees
                });
            }
            if (gender_element.total_back_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_back_name_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Back Name Decor Up Fee",
                    value: gender_element.total_back_name_decor_up_fees
                });
            }
            if (gender_element.total_back_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_back_number_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Back Number Decor Up Fee",
                    value: gender_element.total_back_number_decor_up_fees
                });
            }

            // Final Total Run Charge
            gender_element.total_color_fee = parseFloat(
                gender_element.total_color_fee.toFixed(2)
            );

            // Setup Fee & Other Services
            const masterServicePricing = activeService.master_service;
            if (
                masterServicePricing &&
                total_group_quantity > 0 &&
                gender_element.total_decoration_colors > 0
            ) {
                const feeStructure = masterServicePricing.fee_structure;
                const setupFeeColor1 = parseFloat(
                    masterServicePricing.setup_fee_color1 || 0
                );
                const setupFeeMulticolor = parseFloat(
                    masterServicePricing.setup_fee_multicolor || 0
                );
                gender_element.per_color_setup_cost = setupFeeColor1;
                if (feeStructure == "1") {
                    this.setup_fee = parseFloat(
                        (
                            setupFeeColor1 *
                            gender_element.total_decoration_colors
                        ).toFixed(2)
                    );
                } else if (feeStructure == "2") {
                    if (gender_element.total_decoration_colors === 1) {
                        this.setup_fee = parseFloat(setupFeeColor1.toFixed(2));
                    } else if (gender_element.total_decoration_colors > 1) {
                        this.setup_fee = parseFloat(
                            setupFeeMulticolor.toFixed(2)
                        );
                    }
                }
                gender_element.total_setup_fee = this.setup_fee;
                if (this.setup_fee > 0)
                    this.setup_fee_applied_gender_index = index;
            }

            const otherServicesTotal = this.otherServices.reduce(
                (total, service) => {
                    const cost = parseFloat(service.retail_cost) || 0;
                    if (service.fee_structure === "Per Item") {
                        return total + cost * total_group_quantity;
                    } else {
                        return total + cost;
                    }
                },
                0
            );

            // preDiscountTotal
            const preDiscountTotal = parseFloat(
                (
                    gender_element.subtotal + // Base item costs
                    gender_element.total_color_fee + // run charges
                    gender_element.total_setup_fee + // Setup fee
                    gender_element.total_design_fee + // Design fee
                    otherServicesTotal
                ) // other services
                    .toFixed(2)
            );

            // Promotional Discount
            let mainDiscountAmount = 0;
            const activeDiscount = this.activeProductDiscount;
            if (activeDiscount && preDiscountTotal > 0) {
                let discount_type = activeDiscount.discount_type;
                let discount_value = parseFloat(
                    activeDiscount.discount_value || 0
                );
                if (discount_type == "Percent") {
                    mainDiscountAmount = parseFloat(
                        ((preDiscountTotal * discount_value) / 100).toFixed(2)
                    );
                } else {
                    mainDiscountAmount = parseFloat(
                        Math.min(preDiscountTotal, discount_value).toFixed(2)
                    );
                }
            }
            gender_element.total_discount_value = mainDiscountAmount;

            // Final Total Cost
            gender_element.total_cost = parseFloat(
                (
                    preDiscountTotal - gender_element.total_discount_value
                ).toFixed(2)
            );

            // Breakdown Data Set Karein
            this.currentBreakdown = {
                baseCost: gender_element.subtotal,
                runCharge: gender_element.total_color_fee,
                setupFee: gender_element.total_setup_fee,
                totalCost: gender_element.total_cost,
                totalDiscount: gender_element.total_discount_value,
                designFee: gender_element.total_design_fee,
                runChargeDetails: detailsForRunCharge
            };

            this.$forceUpdate();
        },

        getDarkLightFees(color) {
            const activeService = this.activeDecorationService;
            // Check if color object and active service exist
            if (color && activeService) {
                // Use price_dark and price_light directly from the active service
                if (color.category == "Dark") {
                    return parseFloat(activeService.price_dark || 0);
                } else if (color.category == "Light") {
                    return parseFloat(activeService.price_light || 0);
                }
            }
            // Return 0 if color category doesn't match or data is missing
            return 0;
        },

        calculateEmbroideryPricing(index) {
            const activeService = this.activeDecorationService;
            if (!activeService) {
                console.error(
                    "calculateEmbroideryPricing: activeDecorationService is missing."
                );
                return;
            }

            let gender_element = this.genderGroups[index];
            if (!gender_element) {
                console.error(
                    "calculateEmbroideryPricing: gender_element is missing."
                );
                return;
            }

            let total_group_quantity =
                this.getTotalItemQuantity(gender_element);
            // Reset all gender-level totals
            gender_element.total_discount_value = 0; // Promotional Discount
            gender_element.total_qty = 0;
            gender_element.total_cost = 0;
            gender_element.total_color_fee = 0;
            gender_element.total_setup_fee = 0;
            gender_element.subtotal = 0; // Item total (after decoration discount)
            gender_element.total_design_fee = 0;
            gender_element.total_front_name_fees = 0;
            gender_element.total_back_name_fees = 0;
            gender_element.total_front_number_fees = 0;
            gender_element.total_back_number_fees = 0;
            gender_element.total_front_number_decor_up_fees = 0;
            gender_element.total_back_name_decor_up_fees = 0;
            gender_element.total_back_number_decor_up_fees = 0;
            gender_element.total_non_standard_fees = 0;
            gender_element.total_decoration_colors = 0;
            this.setup_fee = 0;
            this.setup_fee_applied_gender_index = -1;

            let detailsForRunCharge = [];

            // Track total decoration colors count for setup fee calculation
            let total_decoration_colors_count = 0;

            if (gender_element["colors"]) {
                // Get tier price and discount ONCE
                let single_location_price = this.getDecorationPrice();
                let decoration_discount_percentage =
                    this.getDecorationDiscount();

                gender_element["colors"].forEach((selected_color_obj) => {
                    // Reset color-level totals
                    selected_color_obj.total_qty_gender_wise = 0;
                    selected_color_obj.subtotal = 0;
                    selected_color_obj.total_cost_gender_wise = 0;
                    selected_color_obj.total_design_fee = 0;

                    // Loop through each size
                    selected_color_obj["unique_sizes"].forEach((size) => {
                        // Store current tier's price and discount on the size object
                        size.single_location_price = single_location_price;
                        size.decoration_discount_percentage =
                            decoration_discount_percentage;

                        let base_price =
                            size.price_base || this.product.price_base || 0;
                        const activeService = this.activeDecorationService;
                        let markup_percentage = activeService
                            ? activeService.markup_percentage
                            : this.product.price_markup_percentage || 0;
                        let mark_up_cost =
                            (base_price * markup_percentage) / 100;
                        size.markup_price = mark_up_cost;
                        let color_category_price =
                            this.getDarkLightFees(selected_color_obj);
                        size.ink_price = color_category_price;

                        let decoration_discount_amount =
                            (parseFloat(size.single_location_price) *
                                parseFloat(
                                    size.decoration_discount_percentage
                                )) /
                            100;
                        let discounted_decoration_price =
                            parseFloat(size.single_location_price) -
                            decoration_discount_amount;

                        size.cost =
                            parseFloat(base_price) +
                            parseFloat(mark_up_cost) +
                            parseFloat(color_category_price || 0) +
                            discounted_decoration_price;

                        // Calculate totals only if quantity exists
                        if (size.quantity && size.quantity > 0) {
                            size.total_cost =
                                this.icPriceFormat(size.cost, true) *
                                parseInt(size.quantity);
                            selected_color_obj.subtotal += parseFloat(
                                size.total_cost
                            );
                            selected_color_obj.total_cost_gender_wise +=
                                parseFloat(size.total_cost);
                            selected_color_obj.total_qty_gender_wise +=
                                parseInt(size.quantity);
                        } else {
                            size.total_cost = 0;
                        }
                    });

                    // Aggregate design fee
                    gender_element.total_design_fee += parseFloat(
                        selected_color_obj.total_design_fee || 0
                    );
                    // Note: Name and number fees are now calculated from VendorOtherServices below
                    gender_element.total_front_number_decor_up_fees +=
                        parseFloat(
                            selected_color_obj.front_number_decor_up_fees || 0
                        );
                    gender_element.total_back_name_decor_up_fees += parseFloat(
                        selected_color_obj.back_name_decor_up_fees || 0
                    );
                    gender_element.total_back_number_decor_up_fees +=
                        parseFloat(
                            selected_color_obj.back_number_decor_up_fees || 0
                        );

                    // Aggregate up to the gender level
                    gender_element.subtotal += parseFloat(
                        selected_color_obj.subtotal
                    );
                    gender_element.total_qty += parseFloat(
                        selected_color_obj.total_qty_gender_wise
                    );
                });
            }

            // Calculate decoration fee using calcImprintLocationByGender (Old Embroidery Logic)
            const runChargeResult = this.calcImprintLocationByGender();
            const total_decoration_fee = parseFloat(
                runChargeResult.totalCalculatedDecorationFee || 0
            );
            total_decoration_colors_count = runChargeResult.total_colors || 0;
            gender_element.total_decoration_colors =
                total_decoration_colors_count;

            // Add location run charge to total_color_fee
            if (total_decoration_fee > 0) {
                gender_element.total_color_fee += total_decoration_fee;
                detailsForRunCharge.push({
                    name: "Location(s) Run Charge",
                    value: parseFloat(total_decoration_fee.toFixed(2))
                });
            }

            // Vendor Color Upcharges
            let vendorColorUpcharge = 0;
            if (this.allDecorationColors && total_group_quantity > 0) {
                for (const [flip, colorHexCodes] of Object.entries(
                    this.allDecorationColors
                )) {
                    if (colorHexCodes) {
                        colorHexCodes.forEach((hexCode) => {
                            if (!hexCode) return;
                            const vendorColor = this.vendorColors.find(
                                (color) =>
                                    color.color_value.toLowerCase() ===
                                    (typeof hexCode === "string"
                                        ? hexCode.toLowerCase()
                                        : hexCode.hex.toLowerCase())
                            );
                            if (vendorColor && vendorColor.decor_upcharge) {
                                vendorColorUpcharge +=
                                    parseFloat(
                                        vendorColor.decor_upcharge || 0
                                    ) * parseInt(total_group_quantity);
                            }
                        });
                    }
                }
            }
            if (vendorColorUpcharge > 0) {
                vendorColorUpcharge = parseFloat(
                    vendorColorUpcharge.toFixed(2)
                );
                gender_element.total_color_fee += vendorColorUpcharge;
                detailsForRunCharge.push({
                    name: "Specialty Ink Fee",
                    value: vendorColorUpcharge
                });
            }

            // Custom Color Fee - Get from VendorOtherServices
            const serviceName = activeService
                ? (activeService.name || "").toLowerCase()
                : "";
            const decorationType =
                activeService && activeService.master_service
                    ? activeService.master_service.decoration_type
                    : 2; // Default to 2 (Embroidery) for calculateEmbroideryPricing

            // Get custom color fee from VendorOtherServices
            let colorMixFeePerColor = this.getColorMixFeeFromVendorServices(
                decorationType,
                serviceName
            );

            // Get unique non-standard color count
            let uniqueNonStandardColorCount =
                this.getUniqueNonStandardColorCount();

            // Calculate mix fee: unique non-standard color count × fee per color (NO quantity multiplication)
            let calculatedMixFee = 0;
            if (
                colorMixFeePerColor !== null &&
                uniqueNonStandardColorCount > 0
            ) {
                calculatedMixFee =
                    uniqueNonStandardColorCount * colorMixFeePerColor;
            }

            gender_element.total_non_standard_fees = calculatedMixFee;
            if (gender_element.total_non_standard_fees > 0) {
                const mixFeeToAdd = parseFloat(
                    gender_element.total_non_standard_fees.toFixed(2)
                );
                gender_element.total_color_fee += mixFeeToAdd;

                // Use "Custom Color Thread Fee" for embroidery (decoration_type == 2), "Custom Color Ink Fee" for print
                const mixFeeLabel =
                    decorationType == 2
                        ? "Custom Color Thread Fee"
                        : "Custom Color Ink Fee";

                detailsForRunCharge.push({
                    name: mixFeeLabel,
                    value: mixFeeToAdd,
                    mixColorCount: uniqueNonStandardColorCount,
                    unitPrice: colorMixFeePerColor || 0,
                    quantity: total_group_quantity
                });
            }

            // Name and Number Fees - Get from VendorOtherServices
            // Only apply if front/back has decorations, calculate based on actual name/number count per location
            const nameFeePerItem = this.getNameFeeFromVendorServices();
            const numberFeePerItem = this.getNumberFeeFromVendorServices();

            // Initialize fees to 0
            gender_element.total_front_name_fees = 0;
            gender_element.total_back_name_fees = 0;
            gender_element.total_front_number_fees = 0;
            gender_element.total_back_number_fees = 0;

            // Count actual names and numbers per location (front/back) based on selected_name_number
            const {
                frontNameCount,
                backNameCount,
                frontNumberCount,
                backNumberCount
            } = this.countNamesAndNumbersByLocation(this.active_gender_index);

            // Check if front or back has decorations
            const { hasFront, hasBack } = this.hasFrontOrBackDecoration(
                this.active_gender_index
            );

            // Only calculate fees if there are actual names/numbers added (count > 0), not just when decoration is added
            if (
                frontNameCount > 0 ||
                backNameCount > 0 ||
                frontNumberCount > 0 ||
                backNumberCount > 0
            ) {
                // Calculate name fees per location (back only - names are only on back)
                if (nameFeePerItem !== null && backNameCount > 0 && hasBack) {
                    gender_element.total_back_name_fees =
                        backNameCount * nameFeePerItem;
                    if (gender_element.total_back_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_back_name_fees;
                        detailsForRunCharge.push({
                            name: "Back Name Fee",
                            value: parseFloat(
                                gender_element.total_back_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: backNameCount
                        });
                    }
                }

                // Calculate number fees per location (front and back)
                if (numberFeePerItem !== null) {
                    // Front number fee - only if numbers are added for front
                    if (frontNumberCount > 0 && hasFront) {
                        gender_element.total_front_number_fees =
                            frontNumberCount * numberFeePerItem;
                        if (gender_element.total_front_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_front_number_fees;
                            detailsForRunCharge.push({
                                name: "Front Number Fee",
                                value: parseFloat(
                                    gender_element.total_front_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: frontNumberCount
                            });
                        }
                    }

                    // Back number fee - only if numbers are added for back
                    if (backNumberCount > 0 && hasBack) {
                        gender_element.total_back_number_fees =
                            backNumberCount * numberFeePerItem;
                        if (gender_element.total_back_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_back_number_fees;
                            detailsForRunCharge.push({
                                name: "Back Number Fee",
                                value: parseFloat(
                                    gender_element.total_back_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: backNumberCount
                            });
                        }
                    }
                }
            }

            // Front Number Decor Up Fee
            if (gender_element.total_front_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_front_number_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Front Number Decor Up Fee",
                    value: gender_element.total_front_number_decor_up_fees
                });
            }

            // Back Name Decor Up Fee
            if (gender_element.total_back_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_back_name_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Back Name Decor Up Fee",
                    value: gender_element.total_back_name_decor_up_fees
                });
            }

            // Back Number Decor Up Fee
            if (gender_element.total_back_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_back_number_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Back Number Decor Up Fee",
                    value: gender_element.total_back_number_decor_up_fees
                });
            }

            // Final Total Run Charge
            gender_element.total_color_fee = parseFloat(
                gender_element.total_color_fee.toFixed(2)
            );

            // Setup Fee calculation (similar to ProductDetails calculateSetupFee)
            this.setup_fee = this.calculateSetupFee(
                activeService,
                gender_element.total_qty,
                total_decoration_colors_count
            );

            // Other Services Total
            const otherServicesTotal = this.otherServices.reduce(
                (total, service) => {
                    const cost = parseFloat(service.retail_cost) || 0;
                    if (service.fee_structure === "Per Item") {
                        return total + cost * total_group_quantity;
                    } else {
                        return total + cost;
                    }
                },
                0
            );

            // preDiscountTotal
            const preDiscountTotal =
                gender_element.subtotal +
                gender_element.total_color_fee +
                this.setup_fee +
                gender_element.total_design_fee +
                otherServicesTotal;

            // Promotional Discount
            let mainDiscountAmount = 0;
            const activeDiscount = this.activeProductDiscount;
            if (activeDiscount && preDiscountTotal > 0) {
                let discount_type = activeDiscount.discount_type;
                let discount_value = parseFloat(
                    activeDiscount.discount_value || 0
                );
                if (discount_type == "Percent") {
                    mainDiscountAmount = parseFloat(
                        ((preDiscountTotal * discount_value) / 100).toFixed(2)
                    );
                } else {
                    mainDiscountAmount = parseFloat(
                        Math.min(preDiscountTotal, discount_value).toFixed(2)
                    );
                }
            }
            gender_element.total_discount_value = mainDiscountAmount;

            // Final Total Cost
            gender_element.total_cost = parseFloat(
                (
                    preDiscountTotal - gender_element.total_discount_value
                ).toFixed(2)
            );
            gender_element.total_setup_fee = this.setup_fee;
            if (this.setup_fee > 0) {
                this.setup_fee_applied_gender_index = index;
            }

            // Breakdown Data Set
            this.currentBreakdown = {
                baseCost: gender_element.subtotal,
                runCharge: gender_element.total_color_fee,
                setupFee: gender_element.total_setup_fee,
                totalCost: gender_element.total_cost,
                totalDiscount: gender_element.total_discount_value,
                designFee: gender_element.total_design_fee,
                runChargeDetails: detailsForRunCharge
            };

            this.$forceUpdate();
        },

        calculateSetupFee(activeService, totalQuantity, totalColors) {
            if (
                !activeService ||
                !activeService.master_service ||
                totalQuantity <= 0
            ) {
                return 0;
            }

            const pricing = activeService.master_service;
            const feeStructure = pricing.fee_structure;
            let calculatedFee = 0;

            if (feeStructure == "1") {
                calculatedFee =
                    parseFloat(pricing.setup_fee_color1 || 0) * totalColors;
            } else if (feeStructure == "2") {
                if (totalColors === 1) {
                    calculatedFee = parseFloat(pricing.setup_fee_color1 || 0);
                } else if (totalColors > 1) {
                    calculatedFee = parseFloat(
                        pricing.setup_fee_multicolor || 0
                    );
                }
            }
            return parseFloat(calculatedFee.toFixed(2));
        },

        converToCamel(text) {
            return text.replace(
                /(^\w|\s\w)(\S*)/g,
                (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
            );
        },

        showBreakupCharges(gender) {
            if (
                this.setup_fee_applied_gender_index >= 0 &&
                gender.total_setup_fee > 0
            ) {
                return true;
            } else if (gender.total_discount_value > 0) {
                return true;
            } else if (gender.total_design_fee > 0) {
                return true;
            } else if (gender.total_color_fee > 0) {
                return true;
            } else if (gender.total_name_number_fees > 0) {
                return true;
            } else if (this.totalNonStandardFees > 0) {
                return true;
            }

            return true;
        },

        disableImprintLocations(disableColors = true) {
            this.disable_imprint_locations = disableColors;
        },

        getAllMarkupTiers(decoration_type, decoration_price_template) {
            return new Promise((resolve, reject) => {
                const params = {
                    decoration_id: decoration_type,
                    template_id: decoration_price_template
                };
                ApiService.query("/get-markup-tiers", { params })
                    .then(({ data }) => {
                        if (data.error) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.markup_tiers = data.markup_tiers;
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },

        getMarkupFromTier(price, decoration_type, decoration_price_template) {
            let markup = 0;
            let tier = this.markup_tiers.find(
                (tier) =>
                    decoration_type == tier.decoration_id &&
                    decoration_price_template == tier.template_id &&
                    parseFloat(tier.start_price) <= parseFloat(price) &&
                    parseFloat(tier.end_price) >= parseFloat(price)
            );
            if (tier) {
                markup = tier.markup;
            }
            return markup;
        }
    }
};
</script>
<style>
/* Apply readonly style to the input when the v-select is disabled */
.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected {
    background-color: transparent !important;
}
.vs--disabled .vs__actions {
    opacity: 0.4;
}
.design_studio_up.product_details_update_v3
    .right_section_main
    .right_section
    .popup_right_section
    .popup_dropdown
    .left-chest-
    .select_color
    .owl-carousel
    .owl-stage-outer
    .owl-stage
    .owl-item {
    min-width: 170px !important;
}
.drop_product.dropdown-menu {
    z-index: 9999 !important;
}

.selected-color-box {
    margin-right: 8px;
}

.mix-color-badge {
    margin-right: 8px;
    padding: 2px 6px;
    background: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 11px;
}

.color-fee-display {
    margin-left: 10px;
    white-space: nowrap;
    font-size: 14px;
    color: #2b2b2b;
}

.mix-color-label {
    margin-right: 8px;
}
.select_color:first-child .color-fee-display span {
    margin-top: 40px;
}

/* Moved from inline styles */
.validation-error-text {
    color: red;
}

.label-pointer {
    cursor: pointer;
}

.flex-1 {
    flex: 1;
}

.color-box-margin {
    margin-right: 8px;
}

.mix-color-indicator {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    background: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 3px;
    vertical-align: middle;
}

.fee-display-margin {
    margin-left: auto;
    margin-right: 8px;
}

/* Color box tooltip styling */
.color-box-tooltip {
    position: relative;
    display: inline-block;
    margin-right: 8px;
    cursor: pointer;
}

.color-box-tooltip:hover::after {
    content: attr(data-hex);
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10000;
    margin-bottom: 5px;
    pointer-events: none;
}

.color-box-tooltip:hover::before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: #333;
    margin-bottom: 0;
    z-index: 10000;
    pointer-events: none;
}

.vs__selected .imprint_color_box {
    margin-right: 8px;
    vertical-align: middle;
}
.select_color .v-select {
    min-width: 140px;
}
.number-input {
    padding-left: 5px !important;
}
</style>
